export const conac = [
 {
      "id_trimestre":"SEGUNDO TRIMESTRE 2026",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC2.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN SEGUNDO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2026",
            "archivos_array":[
               {
                  "file_item_nombre":"U-02. Promoción y Rectoría en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2026/02 - Promocion y Rectoria en Salud Evaluacion.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2026/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"S-04. Administración de Ingresos para la Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2026/04 - Administracion de Ingresos para la Salud Evaluacion.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2026/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"M-05. Financiamiento para el Bienestar de la Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2026/05 - Financiamiento para el Bienestar de la Salud Evaluacion.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2026/Reporte de la MIR 5.pdf"
               },
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2026/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2026/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2026/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2026/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2026/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2026/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         },  
      ]
   },     
 {
      "id_trimestre":"PRIMER TRIMESTRE 2026",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS DEL FASSA 2026",
            "archivos_array":[
               {
                  "file_item_nombre":"MIR FASSA 2026",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/MIR FASSA 2026.pdf"
               },
               {
                  "file_item_nombre":"1 Razón de Mortalidad Materna",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/1 Razon de Mortalidad Materna.pdf"
               },
               {
                  "file_item_nombre":"2 Tasa Incidencia Enfermedades Prevenibles por Vacunación",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/2 Tasa Incidencia Enfermedades Prevenibles por Vacunacion.pdf"
               },
               {
                  "file_item_nombre":"3 Porcentaje de Menores de 1a. edad con Esquema completo de Vacunación",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/3 Porcentaje de Menores de 1a edad con Esquema completo de Vacunacion.pdf"
               },
               {
                  "file_item_nombre":"4 Porcentaje de población de 20 años y más con detección de Obesidad",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/4 Porcentaje de poblacion de 20 años y mas con deteccion de Obesidad.pdf"
               },
               {
                  "file_item_nombre":"5 Promedio de avance de Proyectos Municipales",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/5 Promedio de avance de Proyectos Municipales.pdf"
               },
               {
                  "file_item_nombre":"6 Porcentaje de acciones de Difusión Sanitaria",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/6 Porcentaje de acciones de Difusion Sanitaria.pdf"
               },
               {
                  "file_item_nombre":"7 Porcentaje de población alcanzada por las Campañas de Salud Pública",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/7 Porcentaje de poblacion alcanzada por las Campañas de Salud Publica.pdf"
               },
               {
                  "file_item_nombre":"8 Porcentaje de Supervisiones realizadas al Programa de Vacunación",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/8 Porcentaje de Supervisiones realizadas al Programa de Vacunacion.pdf"
               },
               {
                  "file_item_nombre":"Metas MIR FASSA 2026",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/METAS MIR FASSA 2026.pdf"
               },
            ]
         },
         {
            "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN 2026 FEDERAL",
            "archivos_array":[
               {
                  "file_item_nombre":"PAE 2026 FEDERAL",
                  "file_item_url":"../../../contenido/transparencia/conac/Primer Trimestre 2026/PAE2026FEDERAL.pdf"
               },
            ]
         },
         {
            "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN 2026 ESTATAL",
            "archivos_array":[
               {
                  "file_item_nombre":"PAE 2026 ESTATAL",
                  "file_item_url":"../../../contenido/transparencia/conac/Primer Trimestre 2026/PAE2026ESTATAL.pdf"
               },
               {
                  "file_item_nombre":"CRITERIOS DEL PAE ESTATAL",
                  "file_item_url":"../../../contenido/transparencia/conac/Primer Trimestre 2026/Criterios PAE 2026.pdf"
               },
               {
                  "file_item_nombre":"TÉRMINOS DE REFERENCIA PARA LA EVALUACIÓN ESPECÍFICA DE DESEMPEÑO",
                  "file_item_url":"../../../contenido/transparencia/conac/Primer Trimestre 2026/Terminos referencia evaluacion especifica.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PRIMER TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/Evaluacion Programatica-Presupuestal 1er trimestre 2026.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PRIMER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2026",
            "archivos_array":[
               {
                  "file_item_nombre":"02. Promoción y Rectoría en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/02 - Promocion y Rectoria en Salud Evaluacion.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"04. Administración de ingresos para la Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/04 - Administracion de Ingresos para la Salud Evaluacion.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"05. Financiamiento para el Bienestar de la Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/05 - Financiamiento para el Bienestar de la Salud Evaluacion.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/Reporte de la MIR 5.pdf"
               },
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2026/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2026/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2026/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2026/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2026/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2026/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"PRESENTACIÓN POA (ANTEPROYECTO) 2026",
            "archivos_array":[
               {
                  "file_item_nombre":"Criterios Generales 2026",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/Criterios Generales 2026.pdf"
               },
               {
                  "file_item_nombre":"02 - Promoción y Rectoría en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/02 - Promocion y Rectoria de la Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la Matriz de Indicadores (MIR) 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/Reporte de la Matriz de Indicadores MIR 2.pdf"
               }, 
               {
                  "file_item_nombre":"04 - Administración de Ingresos para la Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/04 - Administracion de Ingresos para la Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la Matriz de Indicadores (MIR) 4",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/Reporte de la Matriz de Indicadores MIR 4.pdf"
               },
               {
                  "file_item_nombre":"05 - Financiamiento para el Bienestar de la Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/05 - Financiamiento para el Bienestar de la Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la Matriz de Indicadores (MIR) 5",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2026/Reporte de la Matriz de Indicadores MIR 5.pdf"
               },  
            ]
         },           
      ]
   },   
{
      
      "id_trimestre":"CUARTO TRIMESTRE 2025",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC4.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN CUARTO TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Evaluacion Programatica-Presupuestal 4to trimestre 2025.pdf"
               }
            ]
         },
         {
            
            "titulo_item_nombre":"EVALUACIÓN CUARTO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2025",
            "archivos_array":[
               {
                  "file_item_nombre":"1. Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/1. Conduccion Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2. Promoción y Rectoría en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/2. Promocion y rectoria de la salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Reporte de la MIR 3.pdf"
               },
            ]
         },    
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         },        
      ]
   },
   {
      
      "id_trimestre":"TERCER TRIMESTRE 2025",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC3.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN TERCER TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Evaluacion Programatica-Presupuestal 3er trimestre 2025.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN TERCER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2025",
            "archivos_array":[
               {
                  "file_item_nombre":"1. Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2025/1. Conduccion Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2. Promoción y Rectoría en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2025/2. Promocion y rectoria de la salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2025/3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Reporte de la MIR 3.pdf"
               },
            ]
         },    
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2025/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         },        
      ]
   },
   {
      
      "id_trimestre":"SEGUNDO TRIMESTRE 2025",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC2.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN SEGUNDO TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Evaluacion Programatica-Presupuestal 2do trimestre 2025.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN SEGUNDO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2025",
            "archivos_array":[
               {
                  "file_item_nombre":"1. Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2025/1. Conduccion Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2. Promoción y Rectoría en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2025/2. Promocion y rectoria de la salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2025/3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Reporte de la MIR 3.pdf"
               },
            ]
         },  
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2025/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         },          
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2025",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN PRIMER TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/Evaluacion Programatica-Presupuestal 1er trimestre 2025.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN 2025 FEDERAL",
            "archivos_array":[
               {
                  "file_item_nombre":"PAE 2025 FEDERAL",
                  "file_item_url":"../../../contenido/transparencia/conac/Segundo Trimestre 2025/PAE2025FEDERAL.pdf"
               },
            ]
         },
         {
            "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2025",
            "archivos_array":[
               {
                  "file_item_nombre":"MIR FASSA 2025",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/MIR FASSA 2025.pdf"
               },
               {
                  "file_item_nombre":"1 Ficha Técnica Fin",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/1 Ficha Tecnica Fin.pdf"
               },
               {
                  "file_item_nombre":"2 Ficha Técnica Propósito",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/2 Ficha Tecnica Proposito.pdf"
               },
               {
                  "file_item_nombre":"3 Ficha Técnica Componente 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/3 Ficha Tecnica Componente 1.pdf"
               },
               {
                  "file_item_nombre":"4 Ficha Técnica Componente 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/4 Ficha Tecnica Componente 2.pdf"
               },
               {
                  "file_item_nombre":"5 Ficha Técnica Actividad 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/5 Ficha Tecnica Actividad 1.pdf"
               },
               {
                  "file_item_nombre":"6 Ficha Técnica Actividad 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/6 Ficha Tecnica Actividad 2.pdf"
               },
               {
                  "file_item_nombre":"7 Ficha Técnica Actividad 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/7 Ficha Tecnica Actividad 3.pdf"
               },
               {
                  "file_item_nombre":"Reporte del 2do. Trimestre de 2025",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/Reporte MIR FASSA 2do trimestre 2025.pdf"
               },
               {
                  "file_item_nombre":"Reporte del 4to. Trimestre de 2025 (Preliminar)",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2025/Reporte MIR FASSA 4to trimestre 2025 Preliminar.pdf"
               },
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PRIMER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2025",
            "archivos_array":[
               {
                  "file_item_nombre":"1. Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/1. Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2. Promoción y Rectoría en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/2. Promocion y rectoria de la salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/Reporte de la MIR 3.pdf"
               },
            ]
         }, 
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2025/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2025/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2025/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2025/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2025/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2025/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN 2025 ESTATAL",
            "archivos_array":[
               {
                  "file_item_nombre":"1. PAE 2025",
                  "file_item_url":"../../../contenido/transparencia/conac/Primer Trimestre 2025/PAE2025.pdf"
               },
               {
                  "file_item_nombre":"2. CRITERIOS PAE 2025",
                  "file_item_url":"../../../contenido/transparencia/conac/Primer Trimestre 2025/Criterios PAE 2025.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"PRESENTACIÓN POA 2025",
            "archivos_array":[
               {
                  "file_item_nombre":"Criterios Generales 2025",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/Criterios Generales 2025.pdf"
               },
               {
                  "file_item_nombre":"02 - Promoción y Rectoría de la Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/02 - Promocion y Rectoria de la Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la Matriz de Indicadores para Resultados (MIR) 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2025/Reporte de la Matriz de Indicadores para Resultados.pdf"
               },  
            ]
         },           
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2024",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC4.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN CUARTO TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Evaluacion Programatica-Presupuestal 4to trimestre 2024.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN CUARTO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2024",
            "archivos_array":[
               {
                  "file_item_nombre":"1. Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/1. Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2. Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/2. Prestacion de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"4. Fortalecimiento a la Atención en Salud de la Población Marginada",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/4. Fortalecimiento a la Atención en Salud de la Población Marginada.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"5. Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/5. Prestación gratuita de servicios de salud a las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Reporte de la MIR 5.pdf"
               },
               {
                  "file_item_nombre":"8. Inversión en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/8. Inversion en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 8",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Reporte de la MIR 8.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2024/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         }
             
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2024",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC3.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN TERCER TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Evaluacion Programatica-Presupuestal 3er trimestre 2024.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN TERCER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2024",
            "archivos_array":[
               {
                  "file_item_nombre":"1. Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/01 Conduccion Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2. Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/2. Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"4. Fortalecimiento a la Atención en Salud de la Población Marginada",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/4. Fortalecimiento a la Atención en Salud de la Población Marginada.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"5. Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/5. Prestación gratuita de servicios de salud a las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Reporte de la MIR 5.pdf"
               },
               {
                  "file_item_nombre":"8. Inversión en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/8. Inversion en Salud .pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 8",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Reporte de la MIR 8.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2024/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         }
         
        
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2024",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC2.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN SEGUNDO TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Evaluacion Programatica-Presupuestal 2do trimestre 2024.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN SEGUNDO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2024",
            "archivos_array":[
               {
                  "file_item_nombre":"1. Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2024/01 Conduccion Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2. Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2024/02 Prestacion de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3. Fortalecimiento a la Prestación de Servicios de Salud gratuitos.",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2024/03 Fortalecimiento a la prestacion de Servicios de Salud Gratuitos.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"5. Prestación gratuita de servicios de salud a las personas sin seguridad social.",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2024/05 Prestacion Gratuita de Servicios de Salud  para las Personas sin Seguridad Social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Reporte de la MIR 5.pdf"
               },
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2024/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         }
        
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2024",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN PRIMER TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/Evaluacion Programatica-Presupuestal 1er trimestre 2024.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2024",
            "archivos_array":[
               {
                  "file_item_nombre":"MIR FASSA 2024",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/MIR FASSA 2024.pdf"
               },
               {
                  "file_item_nombre":"1 Ficha Técnica Fin",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/1 Ficha Tecnica Fin.pdf"
               },
               {
                  "file_item_nombre":"2 Ficha Técnica Propósito",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/2 Ficha Tecnica Proposito.pdf"
               },
               {
                  "file_item_nombre":"3 Ficha Técnica Componente 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/3 Ficha Tecnica Componente 1.pdf"
               },
               {
                  "file_item_nombre":"4 Ficha Técnica Componente 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/4 Ficha Tecnica Componente 2.pdf"
               },
               {
                  "file_item_nombre":"5 Ficha Técnica Actividad 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/5 Ficha Tecnica Actividad 1.pdf"
               },
               {
                  "file_item_nombre":"6 Ficha Técnica Actividad 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/6 Ficha Tecnica Actividad 2.pdf"
               },
               {
                  "file_item_nombre":"7 Ficha Técnica Actividad 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/7 Ficha Tecnica Actividad 3.pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA 2° Trimestre 2024",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/Reporte MIR FASSA Segundo Trim 2024.pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA cierre definitivo 2024",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/Reporte MIR FASSA Definitivo 2024.pdf"
               },
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PRIMER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2024",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/1 Conduccion Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/02 - Prestacion de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/03 - Fortalecimiento a la Prestacion de Servicios de Salud Gratuitos.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/Reporte de la MIR 3.pdf"
               },
            ]
         },
         {
            "titulo_item_nombre":"MIR´s PROGRAMAS PRESUPUESTALES 2024 (Anteproyecto)",
            "archivos_array":[
               {
                  "file_item_nombre":"02 - Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/MIR 02 Prestacion de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"03 - Fortalecimiento a la Prestación de Servicios de Salud Gratuitos",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/MIR 03 Fortalecimiento a la Prestacion de Servicios de Salud Gratuitos.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"PRESENTACIÓN POA 2024",
            "archivos_array":[
               {
                  "file_item_nombre":"Resumen Calendarizado del Proyecto del Programa Operativo Anual para el Ejercicio Fiscal 2024",
                  "file_item_url":"../../../contenido/transparencia/conac/Primer Trimestre 2024/Resumen Calendarizado del Proyecto del Programa Operativo Anual para el Ejercicio Fiscal 2024.pdf"
               },
               {
                  "file_item_nombre":"02 - Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/02 - Prestacion de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"03 - Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/03 - Fortalecimiento a la Prestacion de Servicios de Salud Gratuitos.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2024/Reporte de la MIR 3.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2024/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2024/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2024/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2024/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2024/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2024/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACION 2024",
            "archivos_array":[
               {
                  "file_item_nombre":"PAE 2024",
                  "file_item_url":"../../../contenido/transparencia/conac/Primer Trimestre 2024/PAE2024.pdf"
               }
            ]
         }
        
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2023",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC4.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN CUARTO TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Evaluacion Programatica-Presupuestal 4to trimestre 2023.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN CUARTO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2023",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/1 Conduccion Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/02 - Prestacion de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de - salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/03 - Fortalecimiento a la prestacion de servicios de salud gratuitos y rectoria en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/05 - Prestacion gratuita de servicios de salud para las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Reporte de la MIR 5.pdf"
               },
               {
                  "file_item_nombre":"6 - Inversion en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/06 - Inversion en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 6",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Reporte de la MIR 6.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2023/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2023",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC3.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN TERCER TRIMESTRE PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Evaluacion Programatica-Presupuestal 3er trimestre 2023.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN TERCER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2023",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2023/1 Conduccion Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2023/E-02 - Prestacion de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de - salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2023/E-03 - Fortalecimiento a la prestacion de servicios de salud gratuitos y rectoria.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2023/E-05 - Prestacion gratuita de servicios de salud para las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Reporte de la MIR 5.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Pagos retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Pagos retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Personal comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2023/Personal comisionado o con licencia.xlsx"
                  }
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2023",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC2.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Evaluacion Programatica Presupuestal 2do 2023.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN SEGUNDO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2023",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2023/1 Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2023/2 Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de - salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2023/3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoria en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2023/5 Prestación gratuita de servicios de salud a las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Reporte de la MIR 5.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Personal Comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2023/Personal Comisionado o con licencia.xlsx"
                  }
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2023",
      "img_url":"../../../contenido/transparencia/conac/img/CONAC.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Formato 7a) Proyecciones de Ingresos - LDF (2023 – 2028)",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2023/Formato 7 a) Proyecciones de Ingresos - LDF (2023-2028).pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2023/Formato 7 a) Proyecciones de Ingresos - LDF (2023-2028).xlsx"
                  }
               },
               {
                  "file_item_nombre":"Formato 7b) Proyecciones de Egresos – LDF (2023-2028)",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2023/Formato 7 b) Proyecciones de Egresos - LDF (2023-2028).pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2023/Formato 7 b) Proyecciones de Egresos - LDF (2023-2028).xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal Trimestral 2023",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Evaluacion Programatica Presupuestal Trimestral 2023.pdf"
               },
               {
                  "file_item_nombre":"Indicadores de desempeño",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Indicadores de desempeno.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"PAE 2023 ESTATAL",
            "archivos_array":[
               {
                  "file_item_nombre":"PAE 2023 Estatal",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/PAE_2023_Estatal.pdf"
               },
               {
                  "file_item_nombre":"Criterios para la Integración del PAE del Estado de Hidalgo, para el Ejercicio Fiscal 2023",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/CRITERIOS_PAE_2023.pdf"
               },
               {
                  "file_item_nombre":"Términos de Referencia, Evaluación Especifica de Resultados y Aplicabilidad de los Recursos (PAE 2023)",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/1_TdR_Evaluacion_Especifica_de_Resultados_y_Aplicabilidad_de_los_Recursos_(anexo_1).pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"PRESENTACIÓN POA 2023",
            "archivos_array":[
               {
                  "file_item_nombre":"Resumen Calendarizado del Programa Operativo Anual 2023",
                  "file_item_url":"../../../contenido/transparencia/conac/Primer Trimestre 2023/Resumen Calendarizado del Programa Operativo Anual 2023.pdf"
               },
               {
                  "file_item_nombre":"02 - Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/02 - Prestacion de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"03 - Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/03 - Fortalecimiento a la prestacion de servicios de salud gratuitos y rectoria en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Reporte de la MIR 3.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PRIMER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2023",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/1 Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/2 Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2 ",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/5 Prestación gratuita de servicios de salud para las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Reporte de la MIR 5.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"MIR´s PROGRAMAS PRESUPUESTALES 2023 (Anteproyecto)",
            "archivos_array":[
               {
                  "file_item_nombre":"01 - Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/01-Conduccion-Sectorial-en-Salud.pdf"
               },
               {
                  "file_item_nombre":"02 - Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/02 Prestacion de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"03 - Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/03 F- a la prestacion de servicios de salud gratuitos y rectoria en salud.pdf"
               },
               {
                  "file_item_nombre":"05 - Prestación gratuita de servicios de salud para las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/05 P- gratuita de servicios de salud para las personas sin seguridad social.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"PAE 2023 FEDERAL",
            "archivos_array":[
               {
                  "file_item_nombre":"PAE 2023 Federal",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/PAE_2023.pdf"
               },
               {
                  "file_item_nombre":"Informe final de la evaluación del desempeño del FASSA",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Informe final de la evaluación del desempeño del FASSA.pdf"
               },
               {
                  "file_item_nombre":"Formato de Aspectos Relevantes de la Evaluación (FARE)",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Formato de Aspectos Relevantes de la Evaluación (FARE).pdf"
               },
               {
                  "file_item_nombre":"Posición Institucional",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Posición Institucional.pdf"
               },
               {
                  "file_item_nombre":"Aspectos Susceptibles de Mejora (ASM)",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/ASM_PAE_2003.jpg"
               },
            ]
         },
         {
            "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2023",
            "archivos_array":[
               {
                  "file_item_nombre":"MIR FASSA 2023",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/2023_may_29_ord0_22-1-5.pdf"
               },
               {
                  "file_item_nombre":"1 Ficha Técnica Fin",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/1 Ficha Tecnica Fin.pdf"
               },
               {
                  "file_item_nombre":"2 Ficha Técnica Propósito",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/2 Ficha Tecnica Proposito.pdf"
               },
               {
                  "file_item_nombre":"3 Ficha Técnica Componente 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/3 Ficha Tecnica Componente 1.pdf"
               },
               {
                  "file_item_nombre":"4 Ficha Técnica Componente 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/4 Ficha Tecnica Componente 2.pdf"
               },
               {
                  "file_item_nombre":"5 Ficha Técnica Actividad 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/5 Ficha Tecnica Actividad 1.pdf"
               },
               {
                  "file_item_nombre":"6 Ficha Técnica Actividad 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/6 Ficha Tecnica Actividad 2.pdf"
               },
               {
                  "file_item_nombre":"7 Ficha Técnica Actividad 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/7 Ficha Tecnica Actividad 3.pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA 2do trimestre 2023",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Reporte MIR FASSA segundo trimestre 2023.pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA cierre definitivo 2023",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2023/Reporte MIR FASSA cierre definitivo 2023.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2023/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2023/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2023/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2023/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2023/Personal Comisionado o con licencia.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2023/Personal Comisionado o con licencia.xlsx"
                  }
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2022",
      "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN CUARTO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2022",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/1 Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/2 Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/3 F. a la prestación de servicios de salud gratuitos y rectoria en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"4 Fortalecimiento a la atención en salud de la población marginada",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/4 Fortalecimiento a la atención en salud de la población marginada.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/5 P. gratuita de servicios de salud para las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Reporte de la MIR 5.pdf"
               },
               {
                  "file_item_nombre":"6 Inversión en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/6 Inversión en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 6",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Reporte de la MIR 6.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Personal Comisionado.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Personal Comisionado.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2022",
            "archivos_array":[
               
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal 4to. Trimestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Evaluacion Programatica Presupuestal 4to- Trimestre 2022.pdf"
               },
               {
                  "file_item_nombre":"Indicadores de resultado al 4to. Trimestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2022/Indicadores de resultado al 4to- Trimestre 2022.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2022",
      "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN TERCER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2022",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/1 Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/2 Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/3 F. a la prestación de servicios de salud gratuitos y rectoria en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"4 Fortalecimiento a la atención en salud de la población marginada",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/4 Fortalecimiento a la atención en salud de la población marginada.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/5 P. gratuita de servicios de salud para las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Reporte de la MIR 5.pdf"
               },
               {
                  "file_item_nombre":"6 Inversión en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/6 Inversión en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 6",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Reporte de la MIR 6.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Personal Comisionado.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2022/Personal Comisionado.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal 3er. Trimestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/11.- JGSO.10.2 Ev Prog (Metas) FF_firmado.pdf"
               },
               {
                  "file_item_nombre":"Indicadores de resultado al 3er. Trimestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2022/CATALOGO DE INDICADORES MIR Y POA.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2022",
      "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN SEGUNDO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2022",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/1 Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/2 Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2 ",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/5 Prestación gratuita de servicios de salud para las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Reporte de la MIR 5.pdf"
               },
               {
                  "file_item_nombre":"6 Inversión en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/6 Inversión en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 6",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Reporte de la MIR 6.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Personal Comisionado.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Personal Comisionado.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":" Evaluación Programática Presupuestal 2do. Trimestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Evaluación Programática Presupuestal Segundo Trimestre 2022.pdf"
               },
               {
                  "file_item_nombre":" Indicadores de resultado al 2do. Trimestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Indicadores de Resultados al Segundo Trimestre 2022.pdf"
               },
               {
                  "file_item_nombre":" Informe de la Gestión al Primer Semestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Informe de la Gestión al Primer Semestre 2022.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2022",
      "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Formato 7a) Proyecciones de Ingresos - LDF (2022 – 2027)",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2022/Formato 7 a) Proyecciones de Ingresos - LDF (2022-2027).pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2022/Formato 7 a) Proyecciones de Ingresos - LDF (2022-2027).xlsx"
                  }
               },
               {
                  "file_item_nombre":"Formato 7b) Proyecciones de Egresos – LDF (2022-2027)",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2022/Formato 7 b) Proyecciones de Egresos - LDF (2022-2027).pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2022/Formato 7 b) Proyecciones de Egresos - LDF (2022-2027).xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"PRESENTACIÓN POA 2022",
            "archivos_array":[
               {
                  "file_item_nombre":" Resumen Calendarizado del Programa Operativo Anual 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Resumen Calendarizado del Programa Operativo Anual 2022.pdf"
               },
               {
                  "file_item_nombre":"02 - Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"03 - Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"05 - Prestación gratuita de servicios de salud para las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Prestación gratuita de servicios de salud para las personas sin seguridad social.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2022 (Anteproyecto)",
            "archivos_array":[
               {
                  "file_item_nombre":"01 - Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"02 - Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"03 - Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"05 - Prestación gratuita de servicios de salud para las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Prestación gratuita de servicios de salud para las personas sin seguridad social.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PRIMER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2022",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/1 Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/2 Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2 ",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/5 Prestación gratuita de servicios de salud para las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Reporte de la MIR 5.pdf"
               },
               {
                  "file_item_nombre":"6 Inversión en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/6 Inversión en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 6",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Reporte de la MIR 6.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2022/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2022/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2022/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2022/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2022/Personal Comisionado.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2022/Personal Comisionado.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":" Evaluación Programática Presupuestal 1er. Trimestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/12.- JGSO.11.1 - Evaluación Programatica - Metas x Componente_firmado.pdf"
               },
               {
                  "file_item_nombre":" Indicadores de resultado al 1er. Trimestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/12.- JGSO.13.18 - Indicadores de Resultados_firmado.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN 2022",
            "archivos_array":[
               {
                  "file_item_nombre":"Programa Anual de Evaluación (PAE) 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Programa Anual de Evaluación (PAE) 2022.pdf"
               },
               {
                  "file_item_nombre":"Nota metodológica (Anexo 4)",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/Nota metodológica (Anexo 4).pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Conducción Sectorial",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/1 Ficha Ejecutiva de Desempeño Conducción Sectorial.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/2 Ficha Ejecutiva de Desempeño Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Fortalecimiento a la Protección Social y Rectoría en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/3 Ficha Ejecutiva de Desempeño Fortalecimiento a la Protección Social y Rectoría en Salud.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Fortalecimiento a la atención en salud de población que habita en comunidades marginadas",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/4 Ficha Ejecutiva de Desempeño Fortalecimiento a la atención en salud de población que habita en comunidades marginadas.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Fortalecimiento a la Atención, Prevención y Promoción de la Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/5 Ficha Ejecutiva de Desempeño Fortalecimiento a la Atención, Prevención y Promoción de la Salud.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Inversión en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2022/6 Ficha Ejecutiva de Desempeño Inversión en Salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2022",
            "archivos_array":[
               {
                  "file_item_nombre":"MIR FASSA 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/MIR FASSA 2022 publicación.pdf"
               },
               {
                  "file_item_nombre":"1 Ficha Técnica Fin",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/1 Ficha Técnica Fin.pdf"
               },
               {
                  "file_item_nombre":"2 Ficha Técnica Propósito",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/2 Ficha Técnica Propósito.pdf"
               },
               {
                  "file_item_nombre":"3 Ficha Técnica Componente 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/3 Ficha Técnica Componente 1.pdf"
               },
               {
                  "file_item_nombre":"4 Ficha Técnica Componente 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/4 Ficha Técnica Componente 2.pdf"
               },
               {
                  "file_item_nombre":"5 Ficha Técnica Actividad 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/5 Ficha Técnica Actividad 1.pdf"
               },
               {
                  "file_item_nombre":"6 Ficha Técnica Actividad 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/6 Ficha Técnica Actividad 2.pdf"
               },
               {
                  "file_item_nombre":"7 Ficha Técnica Actividad 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/7 Ficha Técnica Actividad 3.pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA 2do trimestre 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Reporte MIR FASSA 2do trimestre 2022 publicación.pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA cuarto trimestre 2022 preliminar",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Reporte MIR FASSA cuarto trimestre 2022 preliminar.pdf"
               },
               {
                  "file_item_nombre":"Reporte de MIR FASSA 4to trimestre Definitivo",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Reporte de MIR FASSA 4to trimestre Definitivo.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"PAE 2022 FEDERAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Ficha de Desempeño, Hidalgo 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Ficha de Desempeño, Hidalgo 2022.pdf"
               },
               {
                  "file_item_nombre":"FARE Hidalgo, 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/FARE Hidalgo, 2022.pdf"
               },
               {
                  "file_item_nombre":"Posición Institucional, Hidalgo, 2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Posición Institucional, Hidalgo, 2022.pdf"
               },
               {
                  "file_item_nombre":"Oficio DGPYP-2227-2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Oficio DGPYP-2227-2022.pdf"
               },
               {
                  "file_item_nombre":"Anexo Oficio DGPYP-2227-2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Anexo Oficio DGPYP-2227-2022.pdf"
               },
               {
                  "file_item_nombre":"Criterios Ficha Desempeño CONEVAL",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2022/Criterios Ficha Desempeño CONEVAL.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2021",
      "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN CUARTO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2021",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/1 Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/2 Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2 ",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"4 Fortalecimiento a la atención en salud de la población marginada",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/4 Fortalecimiento a la atención en salud de la población marginada.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/5 Prestación gratuita de servicios de salud a las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Reporte de la MIR 5.pdf"
               },
               {
                  "file_item_nombre":"6 Inversión en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/6 Inversion en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 6",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Reporte de la MIR 6.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"CONVENIO PROGRAMA E023 ejercicio 2021",
            "archivos_array":[
               {
                  "file_item_nombre":"CONVENIO PROGRAMA PRESUPUESTARIO E023 ATENCIÓN A LA SALUD PARA EL EJERCICIO FISCAL 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/00 DOF CONVENIO PSP-E023-2021-HGO-13.pdf"
               },
               {
                  "file_item_nombre":" Programa E023 2021 ANEXO 3 Enero, Febrero, Marzo, Abril y Mayo",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/01 Programa E023 Enero - Mayo.pdf"
               },
               {
                  "file_item_nombre":"Programa E023 2021 ANEXO 3 Junio y Julio",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/02 Programa E023 Junio - Julio 2021.pdf"
               },
               {
                  "file_item_nombre":" Programa E023 2021 ANEXO 3 Agosto",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/03 Programa E023 Agosto 2021.pdf"
               },
               {
                  "file_item_nombre":"Programa E023 2021 ANEXO 3 Septiembre",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/04 Programa E023 Septiembre 2021.pdf"
               },
               {
                  "file_item_nombre":"Programa E023 2021 ANEXO 3 Octubre",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/05 Programa E023 Octubre 2021.pdf"
               },
               {
                  "file_item_nombre":"Programa E023 2021 ANEXO 3 Noviembre",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/06 Programa E023 Noviembre 2021.pdf"
               },
               {
                  "file_item_nombre":"Programa E023 2021 ANEXO 3 Diciembre",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/07 Programa E023 Diciembre 2021.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Personal Comisionado.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Personal Comisionado.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal 4to. Trimestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Evaluación Programática Presupuestal 4to. Trimestre 2021.pdf"
               },
               {
                  "file_item_nombre":"Indicadores de resultado al 4to. Trimestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Indicadores de resultado al 4to. Trimestre 2021.pdf"
               },
               {
                  "file_item_nombre":"Informe de la Gestión al Segundo Semestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2021/Informe de la Gestión al Segundo Semestre 2021.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"Informe Trimestral de Transparencia 2021",
            "descripcion_titulo":"Anexo 7 CAF",
            "archivos_array":[
               {
                  "file_item_nombre":"1er Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/ANEXO  7 1er trimestre.pdf"
               },
               {
                  "file_item_nombre":"2do Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/ANEXO 7 2do trimestre.pdf"
               },
               {
                  "file_item_nombre":"3er Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/ANEXO 7 3er triestre.pdf"
               },
               {
                  "file_item_nombre":"4to Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/ANEXO 7CAF (4to 2021).pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"Informe Trimestral de Transparencia 2020",
            "descripcion_titulo":"Anexo 7 CAF",
            "archivos_array":[
               {
                  "file_item_nombre":"1er Trimestre y 2do Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/1.- ANEXO 7CAF  1ER y 2DO TRIMESTRE.pdf"
               },
               {
                  "file_item_nombre":"3er Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/2.- ANEXO 7CAF 3ER TRIMESTRE.pdf"
               },
               {
                  "file_item_nombre":"4to Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/3.- ANEXO 7CAF  4TO TRIMESTRE.pdf"
               },
               {
                  "file_item_nombre":"5to Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/4.- ANEXO 7CAF  5TO TRIMESTRE.pdf"
               }
            ]
         }

      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2021",
      "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN TERCER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2021",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/1 Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/2 Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2 ",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"4 Fortalecimiento a la atención en salud de la población marginada",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/4 Fortalecimiento a la atención en salud de la población marginada.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/5 Prestación gratuita de servicios de salud a las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Reporte de la MIR 5.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Personal Comisionado.pdf",
                     "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Personal Comisionado.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal 3er. Trimestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Evaluación Programática Presupuestal del 3er Trimestre 2021.pdf"
               },
               {
                  "file_item_nombre":"Indicadores de Resultado al 3er Trimestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2021/Indicadores de Resultado al 3er Trimestre 2021.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2021",
      "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"EVALUACIÓN SEGUNDO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2021",
            "archivos_array":[
               {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/01 - Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/02 - Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2 ",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/03 - Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"4 Fortalecimiento a la atención en salud de la población marginada",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/04 - Fortalecimiento a la atención en salud de la población marginada.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/05 - Prestación gratuita de servicios de salud para las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Reporte de la MIR 5.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Personal Comisionado.pdf",
                     "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Personal Comisionado.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal 2do Trimestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Evaluación Programática Presupuestal 2do Trimestre 2021.pdf"
               },
               {
                  "file_item_nombre":"Indicadores de resultado al 2do Trimestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Indicadores de resultado al 2do Trimestre 2021.pdf"
               },
               {
                  "file_item_nombre":"Informe de la Gestión al Primer Semestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2021/Informe de la Gestión al Primer Semestre 2021.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2021",
      "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
      "titulos_array":[
         {
            "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN 2021",
            "archivos_array":[
               {
                  "file_item_nombre":"Programa Anual de Evaluación (PAE) 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Programa Anual de Evaluación (PAE) 2021.pdf"
               },
               {
                  "file_item_nombre":"Nota metodológica (Anexo 2a)",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Nota Metodológica Anexo 2a.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Conducción Sectorial",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Ficha Ejecutiva de Desempeño Conducción Sectorial.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Ficha Ejecutiva de Desempeño Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Fortalecimiento a la Protección Social y Rectoría en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Ficha Ejecutiva de Desempeño Fortalecimiento a la Protección Social y Rectoría en Salud.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Fortalecimiento a la atención en salud de población que habita en comunidades marginadas",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Ficha Ejecutiva de Desempeño Fortalecimiento a la atención en salud de población que habita en comunidades marginadas.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Fortalecimiento a la Atención, Prevención y Promoción de la Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Ficha Ejecutiva de Desempeño Fortalecimiento a la Atención, Prevención y Promoción de la Salud.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Inversión en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Ficha Ejecutiva de Desempeño Inversión en Salud.pdf"
               },
               {
                  "file_item_nombre":"Ficha Ejecutiva de Desempeño Garantía del Aseguramiento",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Ficha Ejecutiva de Desempeño Garantía del Aseguramiento.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN NACIONAL 2021",
            "archivos_array":[
               {
                  "file_item_nombre":"Programa Anual de Evaluación (PAE) 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/nacional/PAEN_2021.pdf"
               },
               {
                  "file_item_nombre":"Informe Final Evaluación Estratégica de Coordinación al FASSA, Ramo 33",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/nacional/Informe final EEC FASSA.pdf"
               },
               {
                  "file_item_nombre":"Formato de Aspectos Relevantes de la Evaluación (FARE)",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/nacional/FARE FASSA coordinacion final.pdf"
               },
               {
                  "file_item_nombre":"Posición Institucional de la Evaluación, Oficio 365-DGPyP-1667-2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/nacional/Posición Inst, oficio 365-DGPYP-1667-2022.pdf"
               },
               {
                  "file_item_nombre":"Anexo de Posición Institucional de la Evaluación, Oficio 365-DGPyP-1667-2022",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/nacional/Anexo Posición Inst. oficio 365-DGPYP-1667-2022.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
            "archivos_array":[
               {
                  "file_item_nombre":" Evaluación Programática Presupuestal 1er. Trimestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Evaluación Programática Presupuestal 1er. Trimestre 2021.pdf"
               },
               {
                  "file_item_nombre":"Indicadores de resultado al 1er. Trimestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Indicadores de Resultado al 31 de marzo de 2021.pdf"
               }
              
            ]
         },
         {
            "titulo_item_nombre":"EVALUACIÓN PRIMER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2021",
            "archivos_array":[
              {
                  "file_item_nombre":"1 Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/01 - Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Reporte de la MIR 1.pdf"
               },
               {
                  "file_item_nombre":"2 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/02 - Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 2 ",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Reporte de la MIR 2.pdf"
               },
               {
                  "file_item_nombre":"3 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/03 - Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Reporte de la MIR 3.pdf"
               },
               {
                  "file_item_nombre":"4 Fortalecimiento a la atención en salud de la población marginada",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/04 - Fortalecimiento a la atención en salud de la población marginada.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 4",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Reporte de la MIR 4.pdf"
               },
               {
                  "file_item_nombre":"5 Prestación gratuita de servicios de salud a las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/05 - Prestación gratuita de servicios de salud para las personas sin seguridad social.pdf"
               },
               {
                  "file_item_nombre":"Reporte de la MIR 5",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Reporte de la MIR 5.pdf"
               }
              
            ]
         },
         {
            "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2021 (Anteproyecto)",
            "archivos_array":[
               {
                  "file_item_nombre":"01 - Conducción Sectorial en Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/01 - Conducción Sectorial en Salud.pdf"
               },
               {
                  "file_item_nombre":"02 - Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/02 - Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"03 - Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/MIR Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"05 - Prestación gratuita de servicios de salud para las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/MIR Prestación gratuita de servicios de salud para las personas sin seguridad social.pdf"
               }
              
            ]
         },
         {
            "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2021",
            "archivos_array":[
              {
                  "file_item_nombre":"MIR FASSA 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Mir Fassa 2021.pdf"
               },
               {
                  "file_item_nombre":"1 Ficha Técnica Fin",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/1 Ficha Técnica Fin.pdf"
               },
               {
                  "file_item_nombre":"2 Ficha Técnica Propósito",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/2 Ficha Técnica Propósito.pdf"
               },
               {
                  "file_item_nombre":"3 Ficha Técnica Componente 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/3 Ficha Técnica Componente 1.pdf"
               },
               {
                  "file_item_nombre":"4 Ficha Técnica Componente 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/4 Ficha Técnica Componente 2.pdf"
               },
               {
                  "file_item_nombre":"5 Ficha Técnica Actividad 1",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/5 Ficha Técnica Actividad 1.pdf"
               },
               {
                  "file_item_nombre":"6 Ficha Técnica Actividad 2",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/6 Ficha Técnica Actividad 2.pdf"
               },
               {
                  "file_item_nombre":"7 Ficha Técnica Actividad 3",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/7 Ficha Técnica Actividad 3.pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA segundo trimestre 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Reporte MIR FASSA segundo trimestre 2021 (POE).pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA cuarto trimestre 2021 preliminar",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Reporte MIR FASSA cuarto trimestre 2021.pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA cuarto trimestre 2021 definitivo",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Reporte MIR FASSA 4to trimestre 2021 definitivo publicación.pdf"
               }
              
            ]
         },
         {
            "titulo_item_nombre":"PRESENTACIÓN POA 2021",
            "archivos_array":[
              {
                  "file_item_nombre":"Resumen Calendarizado del Programa Operativo Anual 2021",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/Resumen Calendarizado del Programa Operativo Anual 2021.pdf"
               },
               {
                  "file_item_nombre":"02 Prestación de Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/02 Prestación de Servicios de Salud.pdf"
               },
               {
                  "file_item_nombre":"03 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/03 Fortalecimiento a la prestación de servicios de salud gratuitos y rectoría en salud.pdf"
               },
               {
                  "file_item_nombre":"04 Fortalecimiento a la atención en salud de la población marginada",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/04 Fortalecimiento a la atención en salud de la población marginada.pdf"
               },
               {
                  "file_item_nombre":"05 Prestación gratuita de servicios de salud para las personas sin seguridad social",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2021/05 Prestación gratuita de servicios de salud para las personas sin seguridad social.pdf"
               }
              
            ]
         },
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2021/Pagos diferentes al costo asociado a las plazas.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2021/Pagos diferentes al costo asociado a las plazas.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2021/Pagos Retroactivos.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2021/Pagos Retroactivos.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2021/Personal Comisionado.pdf",
                     "xls":"../../contenido/transparencia/conac/Primer Trimestre 2021/Personal Comisionado.xlsx"
                  }
               }
            ]
         }
      ]
   },
   {
      
      "id_trimestre":"CUARTO TRIMESTRE 2020",
       "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
        "titulos_array":[
      {
      "titulo_item_nombre":"REPORTE DE EVALUACIÓN 4TO TRIMESTRE",
      "archivos_array":[
         {
            "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre de la Secretaria de Salud",
            "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Reporte de evaluación de las MIR's 4to trimestre de la Secretaria de Salud.pdf"
         },
         {
            "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre del OD Servicios de Salud",
            "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Reporte de evaluación de las MIR's 4to trimestre del OD Servicios de Salud.pdf"
         },
         {
            "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre de Inversión en Salud",
            "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Reporte de evaluación de las MIR's 4to trimestre de Inversión en Salud.pdf"
         }
      ]
   },
   {
      "titulo_item_nombre":"",
      "archivos_array":[
         {
            "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
            "nombre":"archivo-pdf",
            "archivos":{
               "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Pagos diferentes al costo asociado a las plazas.pdf",
               "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Pagos diferentes al costo asociado a las plazas.xlsx"
            }
         },
         {
            "file_item_nombre":"Pagos Retroactivos ",
            "nombre":"archivo-pdf",
            "archivos":{
               "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Pagos Retroactivos.pdf",
               "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Pagos Retroactivos.xlsx"
            }
         },
         {
            "file_item_nombre":"Personal Comisionado o con Licencia ",
            "nombre":"archivo-pdf",
            "archivos":{
               "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Personal Comisionado.pdf",
               "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Personal Comisionado.xlsx"
            }
         }
      ]
   },
   {
      "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
      "archivos_array":[
         {
            "file_item_nombre":"Evaluación Programática Presupuestal 4to. Trimestre 2020",
            "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/Evaluación Programatica 4to. Trim. 2020.pdf"
         },
         {
            "file_item_nombre":"Informe de la Gestión del Segundo Semestre 2020",
            "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2020/10.- Informe de la Gestion Segundo Semestre 2020_firmado.pdf"
         }
      ]
   }
]
},
{
      
   "id_trimestre":"TERCER TRIMESTRE 2020",
    "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
     "titulos_array":[
  {
      
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 3ER TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre de la Secretaria de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Reporte de evaluación de las MIR's 3er trimestre de la Secretaria de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Reporte de evaluación de las MIR's 3er trimestre del OD Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre de Inversión en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Reporte de evaluación de las MIR's 3er trimestre de Inversión en Salud.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Personal Comisionado.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Personal Comisionado.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"CONVENIO PU013 2020, Cumplimiento del anexo 6",
         "archivos_array":[
            {
               "file_item_nombre":"CONVENIO PU013 2020",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Convenio PU013 Hidalgo 2020.pdf"
            },
            {
               "file_item_nombre":"PU013 2020 Anexo 6 Marzo, abril, mayo, junio y julio",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/PU013 2020 Anexo 6 Marzo, abril, mayo, junio y julio.pdf"
            },
            {
               "file_item_nombre":"PU013 2020 Anexo 6 Agosto",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/PU013 2020 Anexo 6 Agosto.pdf"
            },
            {
               "file_item_nombre":"PU013 2020 Anexo 6 Septiembre",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/PU013 2020 Anexo 6 Septiembre.pdf"
            },
            {
               "file_item_nombre":"PU013 2020 Anexo 6 Octubre",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/PU013 2020 Anexo 6 Octubre.pdf"
            },
            {
               "file_item_nombre":"PU013 2020 Anexo 6 Noviembre",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/PU013 2020 Anexo 6 Noviembre.pdf"
            },
            {
               "file_item_nombre":"PU013 2020 Anexo 6 Diciembre",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/PU013 2020 Anexo 6 Diciembre.pdf"
            },
            {
               "file_item_nombre":"PU013 2020 Anexo 6 Enero",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/PU013 2020 Anexo 6 Enero.pdf"
            },
            {
               "file_item_nombre":"PU013 2020 Anexo 6 Febrero",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/PU013 2020 Anexo 6 Febrero.pdf"
            },
            {
               "file_item_nombre":"PU013 2020 Anexo 6 Marzo",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/PU013 2020 Anexo 6 Marzo.pdf"
            }
         ]
      },
{
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática Presupuestal  3er. Trimestre 2020",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2020/Evaluación Programática Presupuestal  3er. Trimestre 2020.pdf"
            }
         ]
      }
]
},
{
      
   "id_trimestre":"SEGUNDO TRIMESTRE 2020",
    "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 2DO TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 2do trimestre de la Secretaria de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Reporte de evaluación de las MIR's 2do trimestre de la Secretaria de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 2do trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Reporte de evaluación de las MIR's 2do trimestre del OD Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 2do trimestre de Inversión en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Reporte de evaluación de las MIR's 2do trimestre de Inversión en Salud.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Personal Comisionado.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Personal Comisionado.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática Presupuestal 2do. Trimestre 2020",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2020/Evaluación Programática Presupuestal 2do. Trimestre 2020.pdf"
            },
            {
               "file_item_nombre":"Informe de la Gestión del Primer Semestre 2020",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2020/10.- Evaluación de Gestión_Primer Semestre 2020.pdf"
            }
         ]
      }

]
},
{
      
   "id_trimestre":"PRIMER TRIMESTRE 2020",
    "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 1ER TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre de la Secretaria de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Reporte de evaluacion de las MIRs 1er trimestre de la Secretaria de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Reporte de evaluacion de las MIRs 1er trimestre del OD Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre del OD REPSS",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Reporte de evaluacion de las MIRs 1er trimestre del OD REPSS.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2020",
         "archivos_array":[
            {
               "file_item_nombre":"01 Conducción Sectorial",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/CONDUCCION SECTORIAL.pdf"
            },
            {
               "file_item_nombre":"02 Prestación de Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/02 Prestación de Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"03 Fortalecimiento a la Protección Social y Rectoría en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/03 Fortalecimiento a la Protección Social y Rectoría en Salud.pdf"
            },
            {
               "file_item_nombre":"04 Fortalecimiento a la Atención en Salud de Población que Habita en Comunidades Marginadas",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/04 Fortalecimiento a la atención en salud de población.pdf"
            },
            {
               "file_item_nombre":"05 Fortalecimiento a la Atención, Prevención y Promoción de la Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/05 Fortalecimiento a la Atención, Prevención y Promoción de la Salud.pdf"
            },
            {
               "file_item_nombre":"06 Garantía del Aseguramiento",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/GARANTIA DEL ASEGURAMIENTO.pdf"
            },
            {
               "file_item_nombre":"07 Inversión en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Inversión en Salud.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2020/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2020/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2020/Pagos retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2020/Pagos retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2020/Personal comisionado o con licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2020/Personal comisionado o con licencia.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN 2020",
         "archivos_array":[
            {
               "file_item_nombre":"Programa Anual de Evaluación (PAE) 2020",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/PAE 2020.pdf"
            },
            {
               "file_item_nombre":"Fichas Ejecutivas de Desempeño por Programa Presupuestario",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/TdR Fichas EDPP SFP.pdf"
            },
            {
               "file_item_nombre":"Ficha Ejecutiva de Desempeño Conduccion Sectorial",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Ficha Ejecutiva de Desempeño Conduccion Sectorial.pdf"
            },
            {
               "file_item_nombre":"Ficha Ejecutiva de Desempeño Fortalecimiento a la atencion en salud de poblacion que habita en comunidades marginadas",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Ficha Ejecutiva de Desempeño Fortalecimiento a la atencion en salud de poblacion que habita en comunidades marginadas.pdf"
            },
            {
               "file_item_nombre":"Ficha Ejecutiva de Desempeño Fortalecimiento a la Atencion, Prevencion y Promocion de la Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Ficha Ejecutiva de Desempeño Fortalecimiento a la Atencion, Prevencion y Promocion de la Salud.pdf"
            },
            {
               "file_item_nombre":"Ficha Ejecutiva de Desempeño Fortalecimiento a la Proteccion Social y Rectoria en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Ficha Ejecutiva de Desempeño Fortalecimiento a la Proteccion Social y Rectoria en Salud.pdf"
            },
            {
               "file_item_nombre":"Ficha Ejecutiva de Desempeño Garantia del Aseguramiento",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Ficha Ejecutiva de Desempeño Garantia del Aseguramiento.pdf"
            },
            {
               "file_item_nombre":"Ficha Ejecutiva de Desempeño Inversion en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Ficha Ejecutiva de Desempeño Inversion en Salud.pdf"
            },
            {
               "file_item_nombre":"Ficha Ejecutiva de Desempeño Prestacion de Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Ficha Ejecutiva de Desempeño Prestacion de Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Nota metodológica (Anexo 2a)",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Nota metodológica (Anexo 2a).pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"PRESENTACIÓN POA 2020",
         "archivos_array":[
            {
               "file_item_nombre":"Catálogo de Indicadores 2020",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Catálogo de indicadores POA 2020.pdf"
            },
            {
               "file_item_nombre":"Resumen Anual Programático Presupuestal por Subsidio POA 2020",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Resumen Anual Programático Presupuestal por Subsidio POA 2020.pdf"
            },
            {
               "file_item_nombre":"Resumen Calendarizado Programático Presupuestal por Subsidio POA 2020",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Resumen Calendarizado Programático Presupuestal por Subsidio POA 2020.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática Presupuestal 1er. Trimestre P.O.A. 2020",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Evaluación Programática Presupuestal 1er. Trimestre P.O.A. 2020.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2020",
         "archivos_array":[
            {
               "file_item_nombre":"MIR FASSA 2020",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/MIR FASSA 2020.pdf"
            },
            {
               "file_item_nombre":"1 Ficha Técnica Fin",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/1 Ficha Técnica Fin.pdf"
            },
            {
               "file_item_nombre":"2 Ficha Técnica Propósito",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/2 Ficha Técnica Propósito.pdf"
            },
            {
               "file_item_nombre":"3 Ficha Técnica Componentes",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/3 Ficha Técnica Componentes.pdf"
            },
            {
               "file_item_nombre":"4 Ficha Técnica Actividad 1",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/4 Ficha Técnica Actividad 1.pdf"
            },
            {
               "file_item_nombre":"5 Ficha Técnica Actividad 2",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/5 Ficha Técnica Actividad 2.pdf"
            },
            {
               "file_item_nombre":"6 Ficha Técnica Actividad 3",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/6 Ficha Técnica Actividad 3.pdf"
            },
            {
               "file_item_nombre":"Reporte MIR FASSA segundo trimestre 2020",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Reporte MIR FASSA segundo trimestre 2020.pdf"
            },
            {
               "file_item_nombre":"Reporte MIR FASSA cuarto trimestre 2020 preliminar",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Reporte MIR FASSA cuarto trimestre 2020 preliminar.pdf"
            },
            {
               "file_item_nombre":"Reporte MIR FASSA cuarto trimestre 2020 definitivo",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2020/Reporte MIR FASSA cuarto trimestre 2020 definitivo.pdf"
            }
         ]
      }

]
},
{
      
   "id_trimestre":"CUARTO TRIMESTRE 2019",
    "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 4TO TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre de la Secretaria de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Reporte de evaluación de las MIR's 4to trimestre de la Secretaria de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Reporte de evaluación de las MIR's 4to trimestre del OD Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre del OD REPSS",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Reporte de evaluación de las MIR's 4to trimestre del OD REPSS.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Pagos retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Pagos retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Personal comisionado o con licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Personal comisionado o con licencia.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática Presupuestal 4to. Trimestre P.O.A. 2019",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/Evaluación Programática Presupuestal 4to. Trimestre P.O.A. 2019.pdf"
            },
            {
               "file_item_nombre":"Informe de la Gestión del Segundo Semestre 2019",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2019/11.- Informe de la Gestion_Segundo Semestre 2019.pdf"
            }
         ]
      }
      

]
},
{
      
   "id_trimestre":"TERCER TRIMESTRE 2019",
    "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Personal Comisionado o con licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Personal Comisionado o con licencia.xlsx"
               }
            }
         ]
      },
      {
      
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 3ER TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre de la Secretaria de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Reporte de evaluación de las MIR's 3er trimestre de la Secretaria de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Reporte de evaluación de las MIR's 3er trimestre del OD Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre del OD REPSS",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Reporte de evaluación de las MIR's 3er trimestre del OD REPSS.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"CONVENIO PU013 2019, Cumplimiento del anexo 6",
         "archivos_array":[
            {
               "file_item_nombre":"CONVENIO PU013 2019",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Convenio PU013 Hidalgo 2019.pdf"
            },
            {
               "file_item_nombre":"PU013 2019 Anexo 6, Enero",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/PU013 HIDALGO 2019 Anexo 6, Enero.pdf"
            },
            {
               "file_item_nombre":"PU013 2019 Anexo 6, Febrero",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/PU013 HIDALGO 2019 Anexo 6, Febrero.pdf"
            },
            {
               "file_item_nombre":"PU013 2019 Anexo 6, Marzo",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/PU013 HIDALGO 2019 Anexo 6, Marzo.pdf"
            },
            {
               "file_item_nombre":"PU013 2019 Anexo 6, Julio, Agosto, Sept. Octubre y Nov.",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/PU013 HIDALGO 2019 Anexo 6, Julio, Agosto, Sept. Octubre y Nov..pdf"
            },
            {
               "file_item_nombre":"PU013 2019 Anexo 6, Diciembre",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/PU013 HIDALGO 2019 Anexo 6, Diciembre.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 3er. Trimestre P.O.A. 2019",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2019/Evaluación programática 3er trimestre 2019.pdf"
            }
         ]
      }

]
},
{
      
   "id_trimestre":"SEGUNDO TRIMESTRE 2019",
    "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 2DO TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 2do trimestre de la Secretaría de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Reporte de evaluación de las MIR's 2do trimestre de la Secretaría de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 2do trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Reporte de evaluación de las MIR's 2do trimestre del OD Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 2do trimestre del OD REPSS",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Reporte de evaluación de las MIR's 2do trimestre del OD REPSS.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Personal Comisionado o con licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Personal Comisionado o con licencia.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 2do. Trimestre P.O.A. 2019",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2019/Evaluación Programática Presupuestal 2do Trimestre 2019.pdf"
            },
            {
               "file_item_nombre":"Informe de la Gestión del Primer Semestre 2019",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2019/10.- Informe de la Gestion Primer Semestre 2019.pdf"
            }
         ]
      }

]
},
{
      
   "id_trimestre":"PRIMER TRIMESTRE 2019",
    "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"ESTRUCTURA PROGRAMÁTICA PRESUPUESTAL",
         "archivos_array":[
            {
               "file_item_nombre":"Estructura Programática de la Entidad Federativa Hidalgo",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Estructura Programática de la Entidad Federativa Hidalgo.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2019/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2019/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2019/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2019/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2019/Personal Comisionado o con licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2019/Personal Comisionado o con licencia.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 1ER TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre de la Secretaría de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Reporte de evaluación de las MIR s 1er trimestre de la Secretaria de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Reporte de evaluación de las MIR s 1er trimestre del OD Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre del OD REPSS",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Reporte de evaluación de las MIR s 1er trimestre del OD REPSS.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"CALENDARIO DE PRESUPUESTO DE EGRESOS DEL EJERCICIO FISCAL 2019",
         "archivos_array":[
            {
               "file_item_nombre":"PRIMER TRIMESTRE 2019",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Calendario de Presupuesto de Egresos del Ejercicio Fiscal 2019.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN 2019",
         "archivos_array":[
            {
               "file_item_nombre":"PAE 2019",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/PAE 2019.pdf"
            },
            {
               "file_item_nombre":"Resultado de la Evaluación del Programa Anual de Evaluación 2019",
               "file_item_url":"../../contenido/transparencia/conac/Resultado de la Evaluación del Programa Anual de Evaluación 2019.pdf"
            },
            {
               "file_item_nombre":"Posición Institucional PAE 2019",
               "file_item_url":"../../contenido/transparencia/conac/Posición Institucional PAE 2019.pdf"
            },
            {
               "file_item_nombre":"Minuta ASM Prestación de Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/MINUTA ASM PRESTACION DE SERVICIOS DE SALUD.pdf"
            },
            {
               "file_item_nombre":"Seguimiento  para la Atención de los Aspectos Susceptibles de Mejora (ASM)",
               "file_item_url":"../../contenido/transparencia/conac/Seguimiento  para la Atención de los Aspectos Susceptibles de Mejora (ASM).pdf"
            },
            {
               "file_item_nombre":"Programa de trabajo ASM Prestación de Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/PROGRAMA DE TRABAJO ASM PRESTACIÓN DE SERVICIOS DE SALUD.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"PRESENTACIÓN POA 2019",
         "archivos_array":[
            {
               "file_item_nombre":"Catálogo de Indicadores 2019",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Indicadores.pdf"
            },
            {
               "file_item_nombre":"Resumen Anual Programático Presupuestal por Subsidio POA 2019",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/POA 2019 por tipo de Subsidio.pdf"
            },
            {
               "file_item_nombre":"Resumen Calendarizado Programático Presupuestal por Subsidio POA 2019",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/POA 2019 Calendarizado.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2019",
         "archivos_array":[
            {
               "file_item_nombre":"MIR FASSA 2019",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/MIR FASSA 2019.pdf"
            },
            {
               "file_item_nombre":"Ficha técnica Fin",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Ficha técnica Fin.pdf"
            },
            {
               "file_item_nombre":"Ficha técnica Propósito",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Ficha técnica Propósito.pdf"
            },
            {
               "file_item_nombre":"Ficha técnica Componente 1",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Ficha técnica Componente 1.pdf"
            },
            {
               "file_item_nombre":"Ficha técnica Componente 2",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Ficha técnica Componente 2.pdf"
            },
            {
               "file_item_nombre":"Ficha técnica Actividad 1",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Ficha técnica Actividad 1.pdf"
            },
            {
               "file_item_nombre":"Ficha técnica Actividad 2",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Ficha técnica Actividad 2.pdf"
            },
            {
               "file_item_nombre":"MIR FASSA 2019 Segundo Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/MIR FASSA 2019 Segundo Trimestre.pdf"
            },
            {
               "file_item_nombre":"MIR FASSA 2019 Cuarto Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Reporte MIR FASSA cuarto trimestre 2019 definitivo.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 1er. Trimestre P.O.A. 2019",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/Evaluacion Programática Presupuestal 1er Trim 2019.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2019",
         "archivos_array":[
            {
               "file_item_nombre":"Conducción Sectorial",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/01 Conducción Sectorial.pdf"
            },
            {
               "file_item_nombre":"Prestación de Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/02 Prestación de Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Fortalecimiento a la Protección Social y Rectoría en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/03 Fortalecimiento a la Protección Social y Rectoría en Salud.pdf"
            },
            {
               "file_item_nombre":"Fortalecimiento a la atención en salud de población vulnerable",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/04 Fortalecimiento a la atención en salud de población que habita en comunidades marginadas.pdf"
            },
            {
               "file_item_nombre":"Fortalecimiento a la atención, prevención y promoción de la salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/05 Fortalecimiento a la Atención, Prevención y Promoción de la Salud.pdf"
            },
            {
               "file_item_nombre":"Garantía del Aseguramiento",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/06 Garantía del Aseguramiento.pdf"
            },
            {
               "file_item_nombre":"Inversión en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2019/07 Inversión en Salud.pdf"
            }
         ]
      }

]
},
{
      
   "id_trimestre":"CUARTO TRIMESTRE 2018",
    "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 4TO TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre de Inversión en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Cuarto trimestre 2018 Inversión Preliminar.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Cuarto trimestre 2018 SSH Preliminar.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre de la Secretaria de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Cuarto trimestre 2018 SESA Preliminar.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre del OD REPSS",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Reporte de evaluación de las MIR's 4to trimestre del O.D. REPSS.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Personal Comisionado o con licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Personal Comisionado o con licencia.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 4to. Trimestre P.O.A. 2018",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2018/Evaluación Programática Presupuestal 4to Trim 2018.pdf"
            }
         ]
      },

]
},
{
      
   "id_trimestre":"TERCER TRIMESTRE 2018",
    "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 3ER TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre de Inversión en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Tercer trimestre 2018 Inversión Preliminar.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Tercer trimestre 2018 SSH Preliminar.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre de la Secretaria de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Tercer trimestre 2018 SESA Preliminar.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre del OD REPSS",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Reporte de evaluación de las MIR's 3er trimestre del O.D. REPSS.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Personal Comisionado o con licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Personal Comisionado o con licencia.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 3er. Trimestre P.O.A. 2018",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2018/Evaluación programatica 3er Trimestre P.O.A. 2018.pdf"
            }
         ]
      }

]
},
{
      
   "id_trimestre":"SEGUNDO TRIMESTRE 2018",
    "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 2DO TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 2do trimestre de la Secretaría de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Segundo trimestre 2018 SESA.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 2do trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Segundo trimestre 2018 SSH.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 2do trimestre del OD REPSS",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Reporte de evaluación de las MIR's 2do trimestre del O.D. REPSS.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Personal Comisionado o con licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Personal Comisionado o con licencia.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 2do. Trimestre P.O.A. 2018",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2018/Evaluación programatica 2do Trimestre P.O.A. 2018.pdf"
            }
         ]
      },

]
},
{
      
   "id_trimestre":"PRIMER TRIMESTRE 2018",
    "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"REPORTE DE EVALUACIÓN 1ER TRIMESTRE",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre de la Secretaría de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Primer trimestre 2018 SESA.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Primer trimestre 2018 SSH.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre del OD REPSS",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Reporte de evaluación de las MIR's 1er trimestre del O.D. REPSS.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2018/Pagos diferentes al costo asociado a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2018/Pagos diferentes al costo asociado a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2018/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2018/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2018/Personal Comisionado o con licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2018/Personal Comisionado o con licencia.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":"EVALUACIÓN PROGRAMA OPERATIVO ANUAL",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 1er. Trimestre P.O.A. 2018",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Evaluación Programática Presupuestal Primer Trimestre 2018.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"PROGRAMA ANUAL DE EVALUACIÓN 2018",
         "archivos_array":[
            {
               "file_item_nombre":"PAE 2018",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/PAE 2018.pdf"
            },
            {
               "file_item_nombre":"TDR EVALUACIÓN ESPECÍFICA DE DESEMPEÑO PAE 2018",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/TDR_EVALUACIÓN ESPECÍFICA DE DESEMPEÑO_PAE 2018.pdf"
            },
            {
               "file_item_nombre":"Informe Final de Resultados G. Aseguramiento",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Informe Final de Resultados G. Aseguramiento.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"PRESENTACIÓN POA 2018",
         "archivos_array":[
            {
               "file_item_nombre":"Cartas Descriptivas POA 2018",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Cartas Descriptivas POA 2018.pdf"
            },
            {
               "file_item_nombre":"Catálogo de Indicadores 2018",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Catálogo de Indicadores 2018.pdf"
            },
            {
               "file_item_nombre":"Resumen Anual Programático Presupuestal por Subsidio POA 2018",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Resumen Anual Programático Presupuestal por Subsidio POA 2018.pdf"
            },
            {
               "file_item_nombre":"Resumen Calendarizado Programático Presupuestal por Subsidio POA 2018",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Resumen Calendarizado Programático Presupuestal por Subsidio POA 2018.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2018",
         "archivos_array":[
            {
               "file_item_nombre":"MIR FASSA 2018",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/MIR_R33_FASSA_2018.pdf"
            },
            {
               "file_item_nombre":"Árbol de Problemas y Objetivos",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/MML Arbol_Problemas Objetivos 2018.pdf"
            },
            {
               "file_item_nombre":"MIR FASSA 2018 Primer semestre",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/MIR FASSA 2018 Primer semestre.pdf"
            },
            {
               "file_item_nombre":"MIR FASSA 2018 Segundo semestre",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/MIR FASSA 2018 Segundo semestre.pdf"
            },
            {
               "file_item_nombre":"MIR FASSA 2018 Cuarto Trimestre (Definitivo)",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/MIR FASSA 2018 Cuarto Trimestre (Definitivo).pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2018",
         "archivos_array":[
            {
               "file_item_nombre":"Conducción Sectorial",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/P-01 - Conducción Sectorial.pdf"
            },
            {
               "file_item_nombre":"Prestación de Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/E-02 - Prestación de Servicios de Salud.pdf"
            },
            {
               "file_item_nombre":"Fortalecimiento a la Protección Social y Rectoría en Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/E-03 - Fortalecimiento a la Protección Social y Rectoría en Salud.pdf"
            },
            {
               "file_item_nombre":"Fortalecimiento a la atención en salud de población vulnerable",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/E-04 - Fortalecimiento a la atención en salud de población vulnerable.pdf"
            },
            {
               "file_item_nombre":"Fortalecimiento a la atención, prevención y promoción de la salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/E-05 - Fortalecimiento a la atención, prevención y promoción de la salud.pdf"
            }
         ]
      }

]
},
{
      
      "id_trimestre":"CUARTO TRIMESTRE 2017",
       "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
        "titulos_array":[
         {
            "titulo_item_nombre":"",
            "archivos_array":[
              {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2017/Pagos diferentes al costo asociado a las plazas4.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2017/Pagos diferentes al costo asociado a las plazas4.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2017/Pagos Retroactivos4.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2017/Pagos Retroactivos4.xlsx"
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2017/Personal Comisionado o con licencia4.pdf",
                     "xls":"../../contenido/transparencia/conac/Cuarto Trimestre 2017/Personal Comisionado o con licencia4.xlsx"
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":" ",
            "archivos_array":[
               {
                  "file_item_nombre":"Evaluación Programática Cuarto Trimestre POA 2017",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2017/Evaluación Programática Cuarto Trimestre 2017.pdf"
               },
               {
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto - Cuarto Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2017/Cuarto Trimestre 2017.pdf"
               }
            ]
         },
         /*{
            "titulo_item_nombre":" ",
            "archivos_array":[
               {
                  "file_item_nombre":"Estructura Programatica 2018",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Estructura Programatica2018.xlsx"
               },
               {
                  "file_item_nombre":"Clasificador por Objeto del Gasto 2018",
                  "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2018/Clasificador por Objeto del Gasto 2018.xlsx"
               }
            ]
         },*/
         {
            "titulo_item_nombre":"CUARTO TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2017",
            "archivos_array":[
               {
                  "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre de la Secretaría de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/MIR FASSA 2017/Evaluación 4to trimestre SESA.pdf"
               },
               {
                  "file_item_nombre":"Reporte de evaluación de las MIR's 4to trimestre del OD Servicios de Salud",
                  "file_item_url":"../../contenido/transparencia/conac/MIR FASSA 2017/Evaluación 4to trimestre SSH.pdf"
               }
            ]
         }
  
]
},
{
      
   "id_trimestre":"TERCER TRIMESTRE 2017",
    "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2017/Pagos diferentes al costo asociado  a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2017/Pagos diferentes al costo asociado  a las plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2017/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2017/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2017/Personal Comisionado o con  licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Tercer Trimestre 2017/Personal Comisionado o con  licencia.xlsx"
               }
            },
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática Tercer Trimestre POA 2017",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2017/Evaluación Programática Tercer Trimestre 2017.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto Tercer Trimestre 2017",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2017/Comparativo trimestral por Proyecto.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"TERCER TRIMESTRE MIR'S PROGRAMAS PRESUPUESTALES 2017",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre de la Secretaría de Salud",
               "file_item_url":"../../contenido/transparencia/conac/MIR FASSA 2017/Reporte de evaluación de las MIR's 3er trimestre de la Secretaría de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/MIR FASSA 2017/Reporte de evaluación de las MIR's 3er trimestre del OD Servicios de Salud.pdf"
            }
         ]
      }
      

]
},
{
      
   "id_trimestre":"SEGUNDO TRIMESTRE 2017",
    "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas \n                                        ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2017/Pagos Diferentes al Costo Asociado   a las Plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2017/Pagos Diferentes al Costo Asociado   a las Plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos \n                                        ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2017/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2017/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia \n                                        ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2017/Personal Comisionado o con   Licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Segundo Trimestre 2017/Personal Comisionado o con   Licencia.xlsx"
               }
            },
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática Segundo Trimestre 2017",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2017/Evaluación Programática Segundo Trimestre 2017.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto 2do. trim 2017",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2017/Estado del Ejercicio del Presupuesto 2do. trim 2017.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2017",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre de la Secretaría de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Reporte de evaluación de las MIR's 2do trimestre de la Secretaría de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 3er trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Reporte de evaluación de las MIR's 2do trimestre del OD Servicios de Salud.pdf"
            }
         ]
      }
      

]
},
{
      
   "id_trimestre":"PRIMER TRIMESTRE 2017",
    "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2017/Pagos diferentes al costo asociado  a las plazas.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2017/Pagos Diferentes al Costo Asociado  a las Plazas.xlsx"
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2017/Pagos Retroactivos.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2017/Pagos Retroactivos.xlsx"
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2017/Personal comisionado o con  licencia.pdf",
                  "xls":"../../contenido/transparencia/conac/Primer Trimestre 2017/Personal Comisionado o con  Licencia.xlsx"
               }
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática Primer Trimestre 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Evaluación Programática Primer Trimestre 2017.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto 1er. trim 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Estado del Ejercicio del Presupuesto 1er. trim 2017.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"PRESENTACIÓN POA 2017",
         "archivos_array":[
            {
               "file_item_nombre":"Cartas Descriptivas POA 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Cartas Descriptivas  POA 2017.pdf"
            },
            {
               "file_item_nombre":"Catálogo de Indicadores 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Catálogo de Indicadores 2017.pdf"
            },
            {
               "file_item_nombre":"Informe Ejecutivo POA 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Informe Ejecutivo POA 2017.pdf"
            },
            {
               "file_item_nombre":"Resumen Anual Programático Presupuestal por Subsidio POA 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Resumen Anual Programático Presupuestal por Subsidio POA 2017.pdf"
            },
            {
               "file_item_nombre":"Resumen Calendarizado Programático Presupuestal por Subsidio POA 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Resumen Calendarizado Programático Presupuestal por Subsidio POA 2017.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2017",
         "archivos_array":[
            {
               "file_item_nombre":"MIR FASSA 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/MIR_R33_FASSA_2017 BUENA.pdf"
            },
            {
               "file_item_nombre":"Árbol de Problemas y Objetivos",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/MML Arbol de problemas Arbol de Objetivos 2017.pdf"
            },
            {
               "file_item_nombre":"Reporte MIR FASSA 2017 (Primer Semestre)",
               "file_item_url":"../../contenido/transparencia/conac/MIR FASSA 2017/Reporte MIR FASSA 2017 (Primer Semestre).pdf"
            },
            {
               "file_item_nombre":"Reporte MIR FASSA 2017 (Segundo Semestre)",
               "file_item_url":"../../contenido/transparencia/conac/MIR FASSA 2017/Reporte_Indicadores_PASH_2017.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2017",
         "archivos_array":[
            {
               "file_item_nombre":"Matriz de Indicadores para Resultados",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Matriz de Indicadores para Resultados 2017.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre de la Secretaría de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Reporte de evaluación de las MIR's 1er trimestre de la Secretaría de Salud.pdf"
            },
            {
               "file_item_nombre":"Reporte de evaluación de las MIR's 1er trimestre del OD Servicios de Salud",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Reporte de evaluación de las MIR's 1er trimestre del OD Servicios de Salud.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"Programa Anual de Evaluación 2017",
         "archivos_array":[
            {
               "file_item_nombre":"PAE 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/PAE PUBLICABLE 2017.pdf"
            },
            {
               "file_item_nombre":"Terminos de Referencia para Evaluación Específica de Desempeño 2017",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Terminos de Referencia para Evaluación Específica de Desempeño 2017.pdf"
            },
            {
               "file_item_nombre":"Resultados (numeral cuadragésimo de lo LGSEED y vigésimo primero de los LEED)",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Resultados (numeral cuadragésimo de lo LGSEED y vigésimo primero de los LEED).pdf"
            },
            {
               "file_item_nombre":"Informe Final de Evaluación Especifica de Desempeño FASSA",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Informe Final de Evaluación Especifica de Desempeño FASSA.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"Aspectos Susceptibles de Mejora PAE 2017",
         "archivos_array":[
            {
               "file_item_nombre":"Presentación de Aspectos Susceptibles de Mejora",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Presentación de Aspectos Suceptibles de Mejora.pdf"
            },
            {
               "file_item_nombre":"Avance de seguimiento a los Aspectos Susceptibles de Mejora",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Avace de seguimiento a los Aspectos Suceptibles de Mejora.pdf"
            },
            {
               "file_item_nombre":"Avance total de los Aspectos Susceptibles de Mejora",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Avance Final de los Aspectos Susceptibles de Mejora 2017.pdf"
            },
            {
               "file_item_nombre":"Anexo I. Definición del Problema FASSA",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Anexo I. Definición del Problema FASSA.pdf"
            },
            {
               "file_item_nombre":"Anexo II. Análisis de Involucrados FASSA",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Anexo II. Análisis de Involucrados FASSA.pdf"
            },
            {
               "file_item_nombre":"Anexo III. Árbol del Problema FASSA",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Anexo III. Árbol del Problema FASSA.pdf"
            },
            {
               "file_item_nombre":"Anexo IV. Árbol de Objetivo FASSA",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Anexo IV. Árbol de Objetivo FASSA.pdf"
            },
            {
               "file_item_nombre":"Anexo V. Análisis de Alternativas FASSA",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Anexo V. Análisis de Alternativas FASSA.pdf"
            },
            {
               "file_item_nombre":"Anexo VI. Estructura Analítica del Programa Presupuestario FASSA",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Anexo VI. Estructura Analítica del Programa Presupuestario FASSA.pdf"
            },
            {
               "file_item_nombre":"Formato 4 FASSA 2018",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Formato 4 FASSA 2018.pdf"
            },
            {
               "file_item_nombre":"MIR Gasto Federalizado FASSA",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/MIR Gasto Federalizado FASSA.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"Posición institucional PAE 2017",
         "archivos_array":[
            {
               "file_item_nombre":"Fondo de Aportación para los Servicios de Salud 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2017/Posición Institucional PAE 2017 FASSA.pdf"
            }
         ]
      },

]
},
{
      
   "id_trimestre":"CUARTO TRIMESTRE 2016",
    "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2016/Pagos Diferentes al Costo Asociado  a la Plaza.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2016/Pagos Retroactivos.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Cuarto Trimestre 2016/Personal Comisionado o con  licencia.pdf",
                  "xls":""
               }
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 4to trimestre y cierre POA 2016",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2016/Evaluación Programática 4to trimestre y cierre POA 2016.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2016/Comparativo Trimestral Proyecto.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2016",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte de Evaluación del Cuarto Trimestre MIR 2016",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2016/Reporte de Evaluación del Cuarto Trimestre MIR 2016.pdf"
            },
            /*{
               "file_item_nombre":"Reporte de Evaluación de las MIR´S 2016 Cierre",
               "file_item_url":"../../contenido/transparencia/conac/Reporte de Evaluación de las MIR´S 2016 Cierre.pdf"
            }*/
         ]
      }
      

]
},
{
      
   "id_trimestre":"TERCER TRIMESTRE 2016",
    "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2016/Pagos Diferentes al Costo Asociado a la Plaza.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2016/Pagos Retroactivos.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Tercer Trimestre 2016/Personal Comisionado o Con Licencia.pdf",
                  "xls":""
               }
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 3er. Trimestre POA 2016",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2016/Evaluación Programatica 3er Trimestre 2016.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto - Tercer Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2016/OF_UCEPP09.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2016",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte 3er. Trimestre 2016",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2016/INFORME DE RESULTADOS INDICADORES SSAH TERCER TRIMESTRE.pdf"
            }
            
         ]
      }
      

]
},
{
      
   "id_trimestre":"SEGUNDO TRIMESTRE 2016",
    "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2016/Pagos Diferentes al Costo Asociado a la Plaza.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2016/Pagos Retroactivos.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2016/Personal Comisionado o con Licencia.pdf",
                  "xls":""
               }
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática POA 2016 Segundo Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2016/Evaluacion_Programatica_Presupuestal_2do_trimestre.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto - Segundo Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2016/UCEEP09 Segundo Trim 2016.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2016",
         "archivos_array":[
            {
               "file_item_nombre":"Reporte 2do. Trimestre 2016",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2016/REP. SALUD SEGUNDO TRIMESTRE.pdf"
            }
            
         ]
      }
      

]
},
{
      
   "id_trimestre":"PRIMER TRIMESTRE 2016",
    "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2016/Pagos Diferentes al Costo Asociado a la Plaza.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2016/Pagos Retroactivos.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2016/Personal Comisionado o con Licencia (1).pdf",
                  "xls":""
               }
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Resumen del POA por tipo de Subsidio 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/PROGRAMA OPERATIVO ANUAL 2016.pdf"
            },
            {
               "file_item_nombre":"Evaluación Programática 1er. Trimestre POA 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Evaluación Programática 1er. Trimestre POA 2016.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto - Primer Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Estado del Ejercicio por Proyecto 1er. Trimestre 2016.pdf"
            },
            
         ]
      },
      {
         "titulo_item_nombre":"MATRIZ DE INDICADORES PARA RESULTADOS MIR FASSA 2016",
         "archivos_array":[
            {
               "file_item_nombre":"MIR FASSA 2016",
               "file_item_url":"../../contenido/transparencia/conac/MIR FASSA 2016/MIR_FASSA_2016.pdf"
            },
            {
               "file_item_nombre":"MML Árbol de Problemas",
               "file_item_url":"../../contenido/transparencia/conac/MIR FASSA 2016/MML-Arbol de problemas-Arbol de Objetivos 2016.pdf"
            },
            {
               "file_item_nombre":"Reporte MIR FASSA 2016 (Primer Semestre)",
               "file_item_url":"./contenido/transparencia/conac/Reporte MIR FASSA 2016 (Primer Semestre).pdf"
            },
            {
               "file_item_nombre":"Reporte MIR FASSA 2016 (Pre - Cierre)",
               "file_item_url":"../../contenido/transparencia/conac/Reporte MIR FASSA 2016 (Pre – Cierre).pdf"
            },
            {
               "file_item_nombre":"Reporte cierre definitivo MIR FASSA 2016",
               "file_item_url":"../../contenido/transparencia/conac/Reporte cierre definitivo MIR FASSA 2016.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2016",
         "archivos_array":[
            {
               "file_item_nombre":"Matriz de Indicadores de Resultados 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/MIR 2016.pdf"
            },
            {
               "file_item_nombre":"Reporte 1er. Trimestre 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/SRI-SALUD TRIMESTRAL.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"PRESENTACIÓN POA 2016",
         "archivos_array":[
            {
               "file_item_nombre":"Cartas Descriptivas POA 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Cartas Descriptivas POA 2016.pdf"
            },
            {
               "file_item_nombre":"Catálogo de Indicadores 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/CATALOGO DE INDICADORES 2016 (2).pdf"
            },
            {
               "file_item_nombre":"Informe Ejecutivo POA 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Informe Ejecutivo POA 2016.pdf"
            },
            {
               "file_item_nombre":"Resumen Anual Programático Presupuestal por Subsidio POA 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Resumen Anual Programático Presupuestal por subsidio POA 2016.pdf"
            },
            {
               "file_item_nombre":"Resumen Calendarizado Programático Presupuestal por Subsidio POA 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Resumen calendarizado Programático Presupuestal por subsidio POA 2016.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"Programa Anual de Evaluación 2016",
         "archivos_array":[
            {
               "file_item_nombre":"PAE 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/PAE 2016.pdf"
            },
            {
               "file_item_nombre":"Términos de Referencia para la Evaluación de Consistencia y Resultados 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/TdR Consistencia y Resultados 2016.pdf"
            },
            {
               "file_item_nombre":"Términos de Referencia para la Evaluación Específica de Desempeño 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/TdR Específica de Desempeño 2016.pdf"
            },
            {
               "file_item_nombre":"Evaluación Específica de Desempeño FASSA 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Eval. Especif.FASSA.pdf"
            },
            {
               "file_item_nombre":"Evaluación Específica de Desempeño FAFEF 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Eval. Especif. FAFEF.pdf"
            },
            {
               "file_item_nombre":"Evaluación Específica de Desempeño FONREGION 2016",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Eval. Especif. FONREGION.pdf"
            },
            {
               "file_item_nombre":"Resultado de la Evaluación Específica de Desempeño Ejercicio Fiscal 2015 Fondo de Aportaciones para los Servicios de Salud (FASSA)",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Resultado eval especif FASSA_vf1916.pdf"
            },
            {
               "file_item_nombre":"Resultado de la Evaluación Específica de Desempeño Ejercicio Fiscal 2015 Fondo de Aportaciones para el Fortalecimiento de las Entidades Federativas (FAFEF)",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Resultado eval especif FAFEF VF_2112.pdf"
            },
            {
               "file_item_nombre":"Resultado de la Evaluación Específica de Desempeño Ejercicio Fiscal 2015 Fondo Regional (FONREGION)",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2016/Resultado eval especif FONREGION_vf1912.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"Aspectos Susceptibles de Mejora PAE 2016",
         "archivos_array":[
            {
               "file_item_nombre":"ineamientos del Estudio de Regionalización Operativa de Atención a Población Abierta (ERO)",
               "file_item_url":"../../contenido/transparencia/conac/ERO-FASSA.pdf"
            },
            {
               "file_item_nombre":"Regionalización Operativa 2016",
               "file_item_url":"../../contenido/transparencia/conac/Regionalización Operativa 2016.pdf"
            },
            {
               "file_item_nombre":"Resumen Ejecutivo de Población",
               "file_item_url":"../../contenido/transparencia/conac/Resumen ejecutivo de población.pdf"
            },
            {
               "file_item_nombre":"MIR FAFEF 2016",
               "file_item_url":"../../contenido/transparencia/conac/MIR FAFEF.pdf"
            },
            {
               "file_item_nombre":"MIR FONREGION 2016",
               "file_item_url":"../../contenido/transparencia/conac/MIR FONREGION.pdf"
            }
         ]
      },

]
},
{
      
      "id_trimestre":"CUARTO TRIMESTRE 2015",
       "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
        "titulos_array":[
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/4to trim 2015/Pagos Diferentes al Costo Asociado a la Plaza.pdf",
                     "xls":""
                  }
               },
               {
                  "file_item_nombre":"Pagos Retroactivos ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/4to trim 2015/Pagos Retroactivos.pdf",
                     "xls":""
                  }
               },
               {
                  "file_item_nombre":"Personal Comisionado o con Licencia ",
                  "nombre":"archivo-pdf",
                  "archivos":{
                     "pdf":"../../contenido/transparencia/conac/4to trim 2015/Personal Comisionado o con Licencia.pdf",
                     "xls":""
                  }
               }
            ]
         },
         {
            "titulo_item_nombre":" ",
            "archivos_array":[
               {
                  "file_item_nombre":"Reporte MIR FASSA 2015 Pre-Cierre",
                  "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Reporte MIR FASSA 2015 Cierre.pdf"
               },
               {
                  "file_item_nombre":"Reporte MIR FASSA 2015 Cierre",
                  "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Reporte MIR FASSA 2015 Cierre Final.pdf"
               },
               {
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto - Cuarto Trimestre",
                  "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/4TO. TRIMESTRE 2015.pdf"
               },
               {
                  "file_item_nombre":"Evaluación Programática Presupuestal 4to. Trimestre y cierre POA 2015",
                  "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Evaluación Progratica 4to. trimestre y cierre POA 2015.pdf"
               },
               {
                  "file_item_nombre":"Informe Final Evaluación Programática POA 2015",
                  "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Informe final Evaluación Programática POA 2015.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"MIR'S PROGRAMAS PRESUPUESTALES 2015",
            "archivos_array":[
               {
                  "file_item_nombre":"Reporte de Evaluación del Cuarto Trimestre MIR 2015",
                  "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/Reporte 4to Trim, 2do Sem, Anual (SALUD).pdf"
               },
               {
                  "file_item_nombre":"Reporte de Evaluación de las MIR´S 2015 Cierre",
                  "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/Reporte Cierre (SALUD).pdf"
               }
            ]
         },
  
]
},
{
      
   "id_trimestre":"TERCER TRIMESTRE 2015",
    "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/conac 3er trimestre 2015/Pagos Diferentes Al Costo Asociado a la Plaza.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/conac 3er trimestre 2015/Pagos Retroactivos.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/conac 3er trimestre 2015/Personal Comisionado o con Licencia.pdf",
                  "xls":""
               }
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática Tercer Trimestre POA 2015",
               "file_item_url":"../../contenido/transparencia/conac/conac 3er trimestre 2015/Evaluacion Programatica Tercer Trimestre POA 2015.pdf"
            },
            {
               "file_item_nombre":"Reporte 3er Trimestre MIR 2015",
               "file_item_url":"../../contenido/transparencia/conac/conac 3er trimestre 2015/Reporte 3er Trimestre MIR 2015.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto - Tercer Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/3ER TRIMESTRE 2015/TERCER TRIMESTRE .pdf"
            }
         ]
      }

]
},
{
      
   "id_trimestre":"SEGUNDO TRIMESTRE 2015",
    "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2015/Pagos Diferentes al Costo Asociado a la Plaza.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2015/Pagos Retroactivos.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Segundo Trimestre 2015/Personal Comisionado o con Licencia.pdf",
                  "xls":""
               }
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 2do Trimestre POA 2015",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2015/Evaluacion POA 2do Trim.pdf"
            },
            {
               "file_item_nombre":"REPORTE 2DO. TRIMESTRE MIR",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2015/REPORTE 2DO. TRIMESTRE MIR.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto - Segundo Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/2DO TRIMESTRE 2015/Estado del Ejercicio del Presupuesto - Segundo Trimestre.pdf"
            }
         ]
      }

]
},
{
      
   "id_trimestre":"PRIMER TRIMESTRE 2015",
    "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":"",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2015/Pagos Diferentes al Costo Asociado a la Plaza.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Pagos Retroactivos ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2015/Pagos Retroactivos.pdf",
                  "xls":""
               }
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia ",
               "nombre":"archivo-pdf",
               "archivos":{
                  "pdf":"../../contenido/transparencia/conac/Primer Trimestre 2015/Personal Comisionado o Con Licencia.pdf",
                  "xls":""
               }
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Cartas Descriptivas-POA 2015",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2015/Cartas Descriptivas-POA 2015.pdf"
            },
            {
               "file_item_nombre":"Catálogo de indicadores-POA 2015",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2015/Catálogo de indicadores-POA 2015.pdf"
            },
            {
               "file_item_nombre":"Esctructura Programática de la Entidad Federativa 2015",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2015/Esctructura Programática de la Entidad Federativa 2015.pdf"
            },
            {
               "file_item_nombre":"Resumen del POA por tipo de subsidio 2015",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2015/Resumen del POA por tipo de subsidio 2015.pdf"
            },
            {
               "file_item_nombre":"Resumen MIR 2015",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2015/Resumen MIR 2015.pdf"
            },
            {
               "file_item_nombre":"REPORTE 1ER. TRIMESTRE MIR",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2015/REPORTE 1ER. TRIMESTRE MIR.pdf"
            },
            {
               "file_item_nombre":"Evaluación Programática 1er Trimestre POA 2015",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2015/Evaluacion POA 1er Trim.pdf"
            },
            {
               "file_item_nombre":"Estado del Ejercicio del Presupuesto - Primer Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/1ER TRIMESTRE  2015/Estado del Ejercicio del Presupuesto - Primer Trimestre.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"Matriz de Indicadores para Resultados MIR FASSA 2015",
         "archivos_array":[
            {
               "file_item_nombre":"MIR FASSA 2015",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2015/MIR FASSA 2015.pdf"
            },
            {
               "file_item_nombre":"Informe de Evaluación  MIR FASSA 2015 Cierre",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2015/Informe de Evaluación  MIR FASSA 2015 Cierre.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":"Programa Anual de Evaluación 2015",
         "archivos_array":[
            {
               "file_item_nombre":"PAE 2015",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/PAE 2015.pdf"
            },
            {
               "file_item_nombre":"Programa Anual de Evaluación 2015",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Programa Anual de Evaluación 2015.pdf"
            },
            {
               "file_item_nombre":"Consistencia y Resultados 2015",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/TdR Consistencia y Resultados 2015.pdf"
            },
            {
               "file_item_nombre":"MINUTAS DE TRABAJO DE ASM A EVALUACIONES (PAE) 2015",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/MINUTAS DE TRABAJO DE ASM A EVALUACIONES (PAE) 2015.pdf"
            },
            {
               "file_item_nombre":"Resultados de la Evaluación  de CyR_FASSA 2015",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Resultados de la Evaluación  de CyR_FASSA 2015.pdf"
            }
         ]
      },

]
},
{
      
   "id_trimestre":"CUARTO TRIMESTRE 2014",
    "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/PAE 2015.pdf"
            },
            {
               "file_item_nombre":"Pagos Retroactivos",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Programa Anual de Evaluación 2015.pdf"
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/TdR Consistencia y Resultados 2015.pdf"
            },
            {
               "file_item_nombre":"Analítico de plazas",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/MINUTAS DE TRABAJO DE ASM A EVALUACIONES (PAE) 2015.pdf"
            },
            {
               "file_item_nombre":"Catálogo de conceptos de percepciones y deducciones",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Resultados de la Evaluación  de CyR_FASSA 2015.pdf"
            },
            {
               "file_item_nombre":"Personal por honorarios",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/PAE 2015.pdf"
            },
            {
               "file_item_nombre":"Plazas existentes",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Programa Anual de Evaluación 2015.pdf"
            },
            {
               "file_item_nombre":"Tabulador",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/TdR Consistencia y Resultados 2015.pdf"
            },
            {
               "file_item_nombre":"Trabajadores comisionados",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/MINUTAS DE TRABAJO DE ASM A EVALUACIONES (PAE) 2015.pdf"
            },
            {
               "file_item_nombre":"Trabajadores con licencia",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Resultados de la Evaluación  de CyR_FASSA 2015.pdf"
            },
            {
               "file_item_nombre":"Trabajadores jubilados y con licencia prejubilatoria",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Resultados de la Evaluación  de CyR_FASSA 2015.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática 4to. trimestre POA 2014",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/PAE 2015.pdf"
            },
            {
               "file_item_nombre":"Informe de Evaluación Programática cierre POA 2014",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/Programa Anual de Evaluación 2015.pdf"
            },
            {
               "file_item_nombre":"Semaforización 4to trimestre Programas Presupuestales 2014",
               "file_item_url":"../../contenido/transparencia/conac/4to trim 2015/PARA PUBLICAR/TdR Consistencia y Resultados 2015.pdf"
            }
           
         ]
      },
      {
         "titulo_item_nombre":"Evaluación de la Matriz de Indicadores para Resultados MIR FASSA 2014",
         "archivos_array":[
            {
               "file_item_nombre":"MIR FASSA",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2014/MIR FASSA.pdf"
            },
            {
               "file_item_nombre":"Semaforizacion de matrices 4to trimestre 2014",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2014/Semaforizacion de matrices 4to trimestre 2014.pdf"
            },
            {
               "file_item_nombre":"Informe de Evaluación MIR FASSA 2014 Cierre",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre 2014/Informe de Evaluación MIR FASSA 2014 Cierre.pdf"
            }
         ]
      }

]
},
{
      
   "id_trimestre":"TERCER TRIMESTRE 2014",
    "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Pagos Diferentes al Costo Asociado a las Plazas.pdf"
            },
            {
               "file_item_nombre":"Pagos Retroactivos",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Pagos Retroactivos.pdf"
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Personal Comisionado o con Licencia.pdf"
            },
            {
               "file_item_nombre":"Analítico de plazas",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Analitico de Plazas.pdf"
            },
            {
               "file_item_nombre":"Catálogo de conceptos de percepciones y deducciones",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Catalogo de Conceptos de Percepciones y Deducciones.pdf"
            },
            {
               "file_item_nombre":"Personal por honorarios",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Personal por Honorarios.pdf"
            },
            {
               "file_item_nombre":"Plazas existentes",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Plazas Existentes.pdf"
            },
            {
               "file_item_nombre":"Tabulador",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Tabulador.pdf"
            },
            {
               "file_item_nombre":"Trabajadores comisionados",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Trabajadores Comisionados.pdf"
            },
            {
               "file_item_nombre":"Trabajadores con licencia",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Trabajadores con Licencia.pdf"
            },
            {
               "file_item_nombre":"Trabajadores jubilados y con licencia prejubilatoria",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Trabajadores Jubilados y con Licencia Prejubilatoria.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre 2014/Evaluacion Programatica POA.pdf"
            }

           
         ]
      }
      

]
},
{
      
   "id_trimestre":"SEGUNDO TRIMESTRE 2014",
    "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Pagos Diferentes al Costo Asociado a las Plazas.pdf"
            },
            {
               "file_item_nombre":"Pagos Retroactivos",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Pagos Retroactivos.pdf"
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Personal Comisionado o con Licencia.pdf"
            },
            {
               "file_item_nombre":"Analítico de plazas",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Analitico de Plazas.pdf"
            },
            {
               "file_item_nombre":"Catálogo de conceptos de percepciones y deducciones",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Catalogo Conceptos de Percepciones y Deducciones.pdf"
            },
            {
               "file_item_nombre":"Personal por honorarios",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Personal por Honorarios.pdf"
            },
            {
               "file_item_nombre":"Plazas existentes",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Plazas Existentes.pdf"
            },
            {
               "file_item_nombre":"Tabulador",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Tabulador.pdf"
            },
            {
               "file_item_nombre":"Trabajadores comisionados",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Trabajadores Comisionados.pdf"
            },
            {
               "file_item_nombre":"Trabajadores con licencia",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Trabajadores con Licencia.pdf"
            },
            {
               "file_item_nombre":"Trabajadores jubilados y con licencia prejubilatoria",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Trabajadores Jubilados y con Licencia Prejubilatoria.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre 2014/Evaluacion Programatica.pdf"
            }

           
         ]
      }
      

]
},
{
      
   "id_trimestre":"PRIMER TRIMESTRE 2014",
    "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Pagos Diferentes al Costo Asociado a las Plazas.pdf"
            },
            {
               "file_item_nombre":"Pagos Retroactivos",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Pagos Retroactivos.pdf"
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Personal Comisionado o con Licencia.pdf"
            },
            {
               "file_item_nombre":"Analítico de plazas",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Analitico de Plazas.pdf"
            },
            {
               "file_item_nombre":"Catálogo de conceptos de percepciones y deducciones",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Catalogo de Conceptos de Percepciones y Deducciones.pdf"
            },
            {
               "file_item_nombre":"Personal por honorarios",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Personal por Honorarios.pdf"
            },
            {
               "file_item_nombre":"Plazas existentes",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Plazas Existentes.pdf"
            },
            {
               "file_item_nombre":"Tabulador",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Tabulador.pdf"
            },
            {
               "file_item_nombre":"Trabajadores comisionados",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Trabajadores Comisionados.pdf"
            },
            {
               "file_item_nombre":"Trabajadores con licencia",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Trabajadores con Licencia.pdf"
            },
            {
               "file_item_nombre":"Trabajadores jubilados y con licencia prejubilatoria",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Trabajadores Jubilados y con Licencia Prejubilatoria.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Evaluacion programatica.pdf"
            },
            {
               "file_item_nombre":"Estructura programática",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Estructura Programatica.pdf"
            },
            {
               "file_item_nombre":"Indicadores",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Indicadores.pdf"
            },
            {
               "file_item_nombre":"Metas anuales",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Metas anuales.pdf"
            }

           
         ]
      },
      {
         "titulo_item_nombre":"Matrices de indicadores para resultados, programas presupuestarios",
         "archivos_array":[
            {
               "file_item_nombre":"Conducción sectorial",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Conduccion Sectorial.pdf"
            },
            {
               "file_item_nombre":"Armonización de la provisión de servicios",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/ Armonizacion de la Provision de Servicios.pdf"
            },
            {
               "file_item_nombre":"Garatía del aseguramiento",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Garantia del Aseguramiento.pdf"
            },
            {
               "file_item_nombre":"Regulación",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Regulacion.pdf"
            },
            {
               "file_item_nombre":"Funciones esenciales de Salud Pública",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre 2014/Funciones Esenciales de Salud Publica.pdf"
            }

           
         ]
      }
      

]
},
{
      
   "id_trimestre":"CUARTO TRIMESTRE 2013",
    "img_url":"../../contenido/transparencia/conac/img/CONAC4.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Pagos Diferentes al Costo Asociado a las Plazas.pdf"
            },
            {
               "file_item_nombre":"Pagos Retroactivos",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Pagos Retroactivos.pdf"
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Personal Comisionado o Con Licencia.pdf"
            },
            {
               "file_item_nombre":"Analítico de plazas",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Analitico de Plazas.pdf"
            },
            {
               "file_item_nombre":"Catálogo de conceptos de percepciones y deducciones",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Catalogo de Conceptos de Percepciones y Deducciones.pdf"
            },
            {
               "file_item_nombre":"Personal por honorarios",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Personal por Honorarios.pdf"
            },
            {
               "file_item_nombre":"Plazas existentes",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Plazas Existentes.pdf"
            },
            {
               "file_item_nombre":"Tabulador",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Tabulador.pdf"
            },
            {
               "file_item_nombre":"Trabajadores comisionados",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Trabajadores Comisionados.pdf"
            },
            {
               "file_item_nombre":"Trabajadores con licencia",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Trabajadores con Licencia.pdf"
            },
            {
               "file_item_nombre":"Trabajadores jubilados y con licencia prejubilatoria",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Trabajadores Jubilados y con Licencia Prejubilatoria.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática",
               "file_item_url":"../../contenido/transparencia/conac/Cuarto Trimestre/Evaluacion 4to trimestre.pdf"
            }
            

           
         ]
      },
      
      

]
},
{
      
   "id_trimestre":"TERCER TRIMESTRE 2013",
    "img_url":"../../contenido/transparencia/conac/img/CONAC3.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Pagos Diferentes al Costo Asociado a las Plazas.pdf"
            },
            {
               "file_item_nombre":"Pagos Retroactivos",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Pagos Retroactivos.pdf"
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Personal Comisionado o Con Licencia.pdf"
            },
            {
               "file_item_nombre":"Analítico de plazas",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Analitico de Plazas.pdf"
            },
            {
               "file_item_nombre":"Catálogo de conceptos de percepciones y deducciones",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Catalogo de Conceptos de Percepciones y Deducciones.pdf"
            },
            {
               "file_item_nombre":"Personal por honorarios",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Personal por Honorarios.pdf"
            },
            {
               "file_item_nombre":"Plazas existentes",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Plazas Existentes.pdf"
            },
            {
               "file_item_nombre":"Tabulador",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Tabulador.pdf"
            },
            {
               "file_item_nombre":"Trabajadores comisionados",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Trabajadores Comisionados.pdf"
            },
            {
               "file_item_nombre":"Trabajadores con licencia",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Trabajadores con Licencia.pdf"
            },
            {
               "file_item_nombre":"Trabajadores jubilados y con licencia prejubilatoria",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Trabajadores Jubilados y con Licencia Prejubilatoria.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Evaluacion programatica presupuestal.pdf"
            }
            

           
         ]
      },
      {
         "titulo_item_nombre":"Evaluación de la Matriz de Indicadores para Resultados MIR FASSA 2013",
         "archivos_array":[
            {
               "file_item_nombre":"Cuarto Trimestre",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Situacion Economica.pdf"
            },
            {
               "file_item_nombre":"Fichas Indicadoras",
               "file_item_url":"../../contenido/transparencia/conac/Tercer Trimestre/Fichas indicadores.pdf"
            }
            

           
         ]
      },
      
      

]
},
{
      
   "id_trimestre":"SEGUNDO TRIMESTRE 2013",
    "img_url":"../../contenido/transparencia/conac/img/CONAC2.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Pagos Diferentes al Costo Asociado a las Plazas.pdf"
            },
            {
               "file_item_nombre":"Pagos Retroactivos",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Pagos Retroactivos.pdf"
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Personal Comisionado o con Licencia.pdf"
            },
            {
               "file_item_nombre":"Analítico de plazas",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Analitico de Plazas.pdf"
            },
            {
               "file_item_nombre":"Catálogo de conceptos de percepciones y deducciones",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Catalogo de Conceptos de Percepciones y Deducciones.pdf"
            },
            {
               "file_item_nombre":"Personal por honorarios",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Personal por Honorarios.pdf"
            },
            {
               "file_item_nombre":"Plazas existentes",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Plazas Existentes.pdf"
            },
            {
               "file_item_nombre":"Tabulador",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Tabulador.pdf"
            },
            {
               "file_item_nombre":"Trabajadores comisionados",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Trabajadores Comisionados.pdf"
            },
            {
               "file_item_nombre":"Trabajadores con licencia",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Trabajadores Con Licencia.pdf"
            },
            {
               "file_item_nombre":"Trabajadores jubilados y con licencia prejubilatoria",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Trabajadores Jubilados y con Licencia Prejubilatoria.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Evaluación Programática",
               "file_item_url":"../../contenido/transparencia/conac/Segundo Trimestre/Evaluacion programatica presupuestal.pdf"
            }
            

           
         ]
      }
      

]
},
{
      
   "id_trimestre":"PRIMER TRIMESTRE 2013",
    "img_url":"../../contenido/transparencia/conac/img/CONAC.jpg",
     "titulos_array":[
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"Pagos Diferentes al Costo Asociado a las Plazas",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Pagos Diferentes al Costo Asociado a las Plazas.pdf"
            },
            {
               "file_item_nombre":"Pagos Retroactivos",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Pagos Retroactivos.pdf"
            },
            {
               "file_item_nombre":"Personal Comisionado o con Licencia",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Personal Comisionado o con Licencia.pdf"
            },
            {
               "file_item_nombre":"Analítico de plazas",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Analitico de Plazas.pdf"
            },
            {
               "file_item_nombre":"Catálogo de conceptos de percepciones y deducciones",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Catalogo de Conceptos de Percepciones y Deducciones.pdf"
            },
            {
               "file_item_nombre":"Personal por honorarios",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Personal por Honorarios.pdf"
            },
            {
               "file_item_nombre":"Plazas existentes",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Metas anuales.pdf"
            },
            {
               "file_item_nombre":"Tabulador",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Tabulador.pdf"
            },
            {
               "file_item_nombre":"Trabajadores comisionados",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Trabajadores Comisionados.pdf"
            },
            {
               "file_item_nombre":"Trabajadores con licencia",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Trabajadores con Licencia.pdf"
            },
            {
               "file_item_nombre":"Trabajadores jubilados y con licencia prejubilatoria",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Trabajadores Jubilados y con Licencia Prejubilatoria.pdf"
            }
         ]
      },
      {
         "titulo_item_nombre":" ",
         "archivos_array":[
            {
               "file_item_nombre":"valuación Programática",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Evaluacion programatica presupuestal.pdf"
            },
            {
               "file_item_nombre":"Estructura programática",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Estructura Programatica.pdf"
            },
            {
               "file_item_nombre":"Indicadores",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Indicadores.pdf"
            },
            {
               "file_item_nombre":"Metas anuales",
               "file_item_url":"../../contenido/transparencia/conac/Primer Trimestre/Metas anuales.pdf"
            }
            

           
         ]
      }
      

]
}
        
]